<template>
  <div>
    <br />
    <h2 class="ViewHeading">Testing Results Portal</h2>
    <div>
      <b-row
        ><b-col>
          <h4>{{ this.selectedlocation }}</h4>
        </b-col></b-row
      >

      <b-row> </b-row>
    </div>
    <b-card>
      <b-tabs>
        <b-tab title="Add Colony Test Results" v-on:click="ChangeTab()" lazy>
          <div>
            <br />
            <b-card v-if="this.UserAccess == 'TSX'">
              <br />
              <b-tabs>
                <b-tab title="Legionella" v-on:click="ChangeTab()" lazy>
                  <p>Choose Test to add results for:</p>
                  <b-table
                    sticky-header
                    no-border-collapse
                    responsive
                    :items="LegionellaColonyForResults"
                    :fields="ForResultsFields"
                    hover
                    small
                    show-empty
                    empty-text="You dont have any Legionella Tests waiting results"
                  >
                    <template v-slot:cell(Update)="{ item }">
                      <b-button
                        variant="outline-info"
                        v-on:click="AddResults(item, 'Colony', 'Legionella')"
                        size="sm"
                        >Update</b-button
                      >
                    </template>
                  </b-table>
                  <br />
                  <b-card v-if="this.ResultsInput == 'True'">
                    <b-row>
                      <b-col class="text-center"
                        ><h3>Colony Results Upload</h3></b-col
                      >
                    </b-row>
                    <b-row>
                      <b-col class="text-center"><h3>Legionella</h3></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col class="text-right"><b>Completed By</b></b-col>
                      <b-col class="text-left">{{
                        this.LegionellaObject.CompletedBy
                      }}</b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col><b>Test ID</b></b-col>
                      <b-col>{{ this.LegionellaObject.TestID }}</b-col>
                      <b-col><b>Location Building</b></b-col>
                      <b-col>{{ this.LegionellaObject.Location }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col><b>Sample Number</b></b-col>
                      <b-col>{{ this.LegionellaObject.SampleID }} </b-col>
                      <b-col><b>Sample Location</b></b-col>
                      <b-col>{{ this.LegionellaObject.SampleLocation }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col><b>Sample Date</b></b-col>
                      <b-col>{{ this.LegionellaObject.SampleDate }} </b-col>
                      <b-col><b>Sample Time</b></b-col>
                      <b-col>{{ this.LegionellaObject.SampleTime }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col><b>Outlet Type</b> </b-col>
                      <b-col>{{ this.LegionellaObject.OutletType }}</b-col>
                      <b-col><b>Post/Pre Flush</b></b-col>
                      <b-col>{{ this.LegionellaObject.FlushType }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col><b>Description</b></b-col>
                      <b-col>{{ this.LegionellaObject.Desc }}</b-col>
                      <b-col></b-col>
                      <b-col></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col><b>Testing Commenced Date</b></b-col>
                      <b-col
                        ><b-form-datepicker
                          v-model="LegionellaObject.TestCommencedDate"
                          locale="en"
                        ></b-form-datepicker
                      ></b-col>
                      <b-col><b>Testing Commenced Time</b></b-col>
                      <b-col
                        ><b-form-timepicker
                          v-model="LegionellaObject.TestCommencedTime"
                          locale="en"
                        ></b-form-timepicker
                      ></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Legionella cfu/1000ml MW28</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.LegVar1"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Legionella pneumophila SG1 cfu/1000ml MW28</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.LegVar2"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Legionella pneumophila SG2-14 cfu/1000ml MW28</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.LegVar3"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Legionella species non pneumophila SG2-14 cfu/1000ml
                        MW28</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.LegVar4"
                      /></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="4"><b>Test Result</b></b-col>
                      <b-col cols="4">
                        <b-select v-model="LegionellaObject.TestResult">
                          <option value="null" disabled
                            >Please Select Test Result</option
                          >
                          <option value="Pass">Pass</option>
                          <option value="Fail">Fail</option>
                        </b-select></b-col
                      >
                    </b-row>
                    <template #footer>
                      <b-row>
                        <b-col></b-col>
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="SubmitForm('Colony', 'Legionella')"
                            >Submit</b-button
                          ></b-col
                        >
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="CancelForm('Colony', 'Legionella')"
                            >Cancel</b-button
                          ></b-col
                        >
                        <b-col></b-col>
                      </b-row>
                    </template>
                  </b-card>
                </b-tab>
                <b-tab title="Pseudomonas" v-on:click="ChangeTab()" lazy>
                  <p>Choose Test to add results for:</p>
                  <b-table
                    sticky-header
                    no-border-collapse
                    responsive
                    :items="PseudomonasColonyForResults"
                    :fields="ForResultsFields"
                    hover
                    small
                    show-empty
                    empty-text="You dont have any Pseudomonas Tests waiting results"
                  >
                    <template v-slot:cell(Update)="{ item }">
                      <b-button
                        variant="outline-info"
                        v-on:click="AddResults(item, 'Colony', 'Pseudomonas')"
                        size="sm"
                        >Update</b-button
                      >
                    </template>
                  </b-table>
                  <br />
                  <b-card v-if="this.ResultsInput == 'True'">
                    <b-row>
                      <b-col class="text-center"
                        ><h3>Colony Results Upload</h3></b-col
                      >
                    </b-row>
                    <b-row>
                      <b-col class="text-center"><h3>Pseudomonas</h3></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col class="text-right">Completed By</b-col>
                      <b-col class="text-left">{{
                        this.PseudomonasObject.CompletedBy
                      }}</b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Test ID</b-col>
                      <b-col>{{ this.PseudomonasObject.TestID }}</b-col>
                      <b-col>Location Building</b-col>
                      <b-col>{{ this.PseudomonasObject.Location }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Number</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleID }} </b-col>
                      <b-col>Sample Location</b-col>
                      <b-col
                        >{{ this.PseudomonasObject.SampleLocation }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Date</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleDate }} </b-col>
                      <b-col>Sample Time</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleTime }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Outlet Type </b-col>
                      <b-col>{{ this.PseudomonasObject.OutletType }}</b-col>
                      <b-col>Post/Pre Flush</b-col>
                      <b-col>{{ this.PseudomonasObject.FlushType }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Description</b-col>
                      <b-col>{{ this.PseudomonasObject.Desc }}</b-col>
                      <b-col></b-col>
                      <b-col></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Testing Commenced Date</b-col>
                      <b-col
                        ><b-form-datepicker
                          v-model="PseudomonasObject.TestCommencedDate"
                          locale="en"
                        ></b-form-datepicker
                      ></b-col>
                      <b-col>Testing Commenced Time</b-col>
                      <b-col
                        ><b-form-timepicker
                          v-model="PseudomonasObject.TestCommencedTime"
                          locale="en"
                        ></b-form-timepicker
                      ></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Aerobic Plate Count 37&#8451; [2 days] cfu/ml
                        MW3</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar1"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Aerobic Plate Count 22&#8451; [3 days] cfu/ml
                        MW3</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar2"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Pseudomonas aeruginosa cfu/100ml MW4</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar3"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Total Coliforms cfu/100ml MW10</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar4"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Escherichia coli cfu/100ml MW10</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar5"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Pseudomonas 30&#8451; cfu/ml MW32</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar6"
                      /></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="4">Test Result</b-col>
                      <b-col cols="4">
                        <b-select v-model="PseudomonasObject.TestResult">
                          <option value="null" disabled
                            >Please Select Test Result</option
                          >
                          <option value="Pass">Pass</option>
                          <option value="Fail">Fail</option>
                        </b-select></b-col
                      >
                    </b-row>
                    <template #footer>
                      <b-row>
                        <b-col></b-col>
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="SubmitForm('Colony', 'Pseudomonas')"
                            >Submit</b-button
                          ></b-col
                        >
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="CancelForm('Colony', 'Pseudomonas')"
                            >Cancel</b-button
                          ></b-col
                        >
                        <b-col></b-col>
                      </b-row>
                    </template>
                  </b-card>
                </b-tab>
              </b-tabs>
            </b-card>
            <b-card v-if="this.UserAccess == 'TSA'">
              <br />
              <b-tabs>
                <b-tab title="Legionella" v-on:click="ChangeTab()" lazy>
                  <p>Choose Test to add results for:</p>
                  <b-table
                    sticky-header
                    no-border-collapse
                    responsive
                    :items="LegionellaColonyForResults"
                    :fields="ForResultsFields"
                    hover
                    small
                    show-empty
                    empty-text="You dont have any Legionella Tests waiting results"
                  >
                    <template v-slot:cell(Update)="{ item }">
                      <b-button
                        variant="outline-info"
                        v-on:click="AddResults(item, 'Colony', 'Legionella')"
                        size="sm"
                        >Update</b-button
                      >
                    </template>
                  </b-table>
                  <br />
                  <b-card v-if="this.ResultsInput == 'True'">
                    <b-row>
                      <b-col class="text-center"
                        ><h3>Colony Results Upload</h3></b-col
                      >
                    </b-row>
                    <b-row>
                      <b-col class="text-center"><h3>Legionella</h3></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col class="text-right">Completed By</b-col>
                      <b-col class="text-left">{{
                        this.LegionellaObject.CompletedBy
                      }}</b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Test ID</b-col>
                      <b-col>{{ this.LegionellaObject.TestID }}</b-col>
                      <b-col>Location Building</b-col>
                      <b-col>{{ this.LegionellaObject.Location }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Number</b-col>
                      <b-col>{{ this.LegionellaObject.SampleID }} </b-col>
                      <b-col>Sample Location</b-col>
                      <b-col>{{ this.LegionellaObject.SampleLocation }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Date</b-col>
                      <b-col>{{ this.LegionellaObject.SampleDate }} </b-col>
                      <b-col>Sample Time</b-col>
                      <b-col>{{ this.LegionellaObject.SampleTime }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Outlet Type </b-col>
                      <b-col>{{ this.LegionellaObject.OutletType }}</b-col>
                      <b-col>Post/Pre Flush</b-col>
                      <b-col>{{ this.LegionellaObject.FlushType }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Description</b-col>
                      <b-col>{{ this.LegionellaObject.Desc }}</b-col>
                      <b-col></b-col>
                      <b-col></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Testing Commenced Date</b-col>
                      <b-col
                        ><b-form-datepicker
                          v-model="LegionellaObject.TestCommencedDate"
                          locale="en"
                        ></b-form-datepicker
                      ></b-col>
                      <b-col>Testing Commenced Time</b-col>
                      <b-col
                        ><b-form-timepicker
                          v-model="LegionellaObject.TestCommencedTime"
                          locale="en"
                        ></b-form-timepicker
                      ></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Legionella cfu/1000ml MW28</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.LegVar1"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Legionella pneumophila SG1 cfu/1000ml MW28</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.LegVar2"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Legionella pneumophila SG2-14 cfu/1000ml MW28</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.LegVar3"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Legionella species non pneumophila SG2-14 cfu/1000ml
                        MW28</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.LegVar4"
                      /></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="4">Test Result</b-col>
                      <b-col cols="4">
                        <b-select v-model="LegionellaObject.TestResult">
                          <option value="null" disabled
                            >Please Select Test Result</option
                          >
                          <option value="Pass">Pass</option>
                          <option value="Fail">Fail</option>
                        </b-select></b-col
                      >
                    </b-row>
                    <template #footer>
                      <b-row>
                        <b-col></b-col>
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="SubmitForm('Colony', 'Legionella')"
                            >Submit</b-button
                          ></b-col
                        >
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="CancelForm('Colony', 'Legionella')"
                            >Cancel</b-button
                          ></b-col
                        >
                        <b-col></b-col>
                      </b-row>
                    </template>
                  </b-card>
                </b-tab>
                <b-tab title="Pseudomonas" v-on:click="ChangeTab()" lazy>
                  <p>Choose Test to add results for:</p>
                  <b-table
                    sticky-header
                    no-border-collapse
                    responsive
                    :items="PseudomonasColonyForResults"
                    :fields="ForResultsFields"
                    hover
                    small
                    show-empty
                    empty-text="You dont have any Pseudomonas Tests waiting results"
                  >
                    <template v-slot:cell(Update)="{ item }">
                      <b-button
                        variant="outline-info"
                        v-on:click="AddResults(item, 'Colony', 'Pseudomonas')"
                        size="sm"
                        >Update</b-button
                      >
                    </template>
                  </b-table>
                  <br />
                  <b-card v-if="this.ResultsInput == 'True'">
                    <b-row>
                      <b-col class="text-center"
                        ><h3>Colony Results Upload</h3></b-col
                      >
                    </b-row>
                    <b-row>
                      <b-col class="text-center"><h3>Pseudomonas</h3></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col class="text-right">Completed By</b-col>
                      <b-col class="text-left">{{
                        this.PseudomonasObject.CompletedBy
                      }}</b-col>
                    </b-row>

                    <b-row>
                      <b-col>Test ID</b-col>
                      <b-col>{{ this.PseudomonasObject.TestID }}</b-col>
                      <b-col>Location Building</b-col>
                      <b-col>{{ this.PseudomonasObject.Location }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Number</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleID }} </b-col>
                      <b-col>Sample Location</b-col>
                      <b-col
                        >{{ this.PseudomonasObject.SampleLocation }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Date</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleDate }} </b-col>
                      <b-col>Sample Time</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleTime }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Outlet Type </b-col>
                      <b-col>{{ this.PseudomonasObject.OutletType }}</b-col>
                      <b-col>Post/Pre Flush</b-col>
                      <b-col>{{ this.PseudomonasObject.FlushType }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Description</b-col>
                      <b-col>{{ this.PseudomonasObject.Desc }}</b-col>
                      <b-col></b-col>
                      <b-col></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Testing Commenced Date</b-col>
                      <b-col
                        ><b-form-datepicker
                          v-model="PseudomonasObject.TestCommencedDate"
                          locale="en"
                        ></b-form-datepicker
                      ></b-col>
                      <b-col>Testing Commenced Time</b-col>
                      <b-col
                        ><b-form-timepicker
                          v-model="PseudomonasObject.TestCommencedTime"
                          locale="en"
                        ></b-form-timepicker
                      ></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Aerobic Plate Count 37&#8451; [2 days] cfu/ml
                        MW3</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar1"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Aerobic Plate Count 22&#8451; [3 days] cfu/ml
                        MW3</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar2"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Pseudomonas aeruginosa cfu/100ml MW4</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar3"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Total Coliforms cfu/100ml MW10</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar4"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Escherichia coli cfu/100ml MW10</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar5"
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Pseudomonas 30&#8451; cfu/ml MW32</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar6"
                      /></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="4">Test Result</b-col>
                      <b-col cols="4">
                        <b-select v-model="PseudomonasObject.TestResult">
                          <option value="null" disabled
                            >Please Select Test Result</option
                          >
                          <option value="Pass">Pass</option>
                          <option value="Fail">Fail</option>
                        </b-select></b-col
                      >
                    </b-row>
                    <template #footer>
                      <b-row>
                        <b-col></b-col>
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="SubmitForm('Colony', 'Pseudomonas')"
                            >Submit</b-button
                          ></b-col
                        >
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="CancelForm('Colony', 'Pseudomonas')"
                            >Cancel</b-button
                          ></b-col
                        >
                        <b-col></b-col>
                      </b-row>
                    </template>
                  </b-card>
                </b-tab>
              </b-tabs>
            </b-card>
            <br />
          </div>
        </b-tab>
        <b-tab
          title="Add Rapid Test Results"
          v-if="this.UserAccess == 'TSA'"
          v-on:click="ChangeTab()"
          lazy
        >
          <div>
            <br />
            <b-card v-if="this.UserAccess == 'TSA'">
              <br />
              <b-tabs>
                <b-tab title="Legionella" v-on:click="ChangeTab()" lazy>
                  <p>Choose Test to add results for:</p>
                  <b-table
                    sticky-header
                    no-border-collapse
                    responsive
                    :items="LegionellaRapidForResults"
                    :fields="ForResultsFields"
                    hover
                    small
                    show-empty
                    empty-text="You dont have any Legionella Tests waiting results"
                  >
                    <template v-slot:cell(Update)="{ item }">
                      <b-button
                        variant="outline-info"
                        v-on:click="AddResults(item, 'Rapid', 'Legionella')"
                        size="sm"
                        >Update</b-button
                      >
                    </template>
                  </b-table>
                  <b-card v-if="this.ResultsInput == 'True'">
                    <b-row>
                      <b-col class="text-center"
                        ><h3>Rapid Results Upload</h3></b-col
                      >
                    </b-row>
                    <b-row>
                      <b-col class="text-center"><h3>Legionella</h3></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col class="text-right">Completed By</b-col>
                      <b-col class="text-left">{{
                        this.LegionellaObject.CompletedBy
                      }}</b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Test ID</b-col>
                      <b-col>{{ this.LegionellaObject.TestID }}</b-col>
                      <b-col>Location Building</b-col>
                      <b-col>{{ this.LegionellaObject.Location }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Number</b-col>
                      <b-col>{{ this.LegionellaObject.SampleID }} </b-col>
                      <b-col>Sample Location</b-col>
                      <b-col>{{ this.LegionellaObject.SampleLocation }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Date</b-col>
                      <b-col>{{ this.LegionellaObject.SampleDate }} </b-col>
                      <b-col>Sample Time</b-col>
                      <b-col>{{ this.LegionellaObject.SampleTime }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Outlet Type </b-col>
                      <b-col>{{ this.LegionellaObject.OutletType }}</b-col>
                      <b-col>Post/Pre Flush</b-col>
                      <b-col>{{ this.LegionellaObject.FlushType }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Description</b-col>
                      <b-col>{{ this.LegionellaObject.Desc }}</b-col>
                      <b-col></b-col>
                      <b-col></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Testing Commenced Date</b-col>
                      <b-col
                        ><b-form-datepicker
                          v-model="LegionellaObject.TestCommencedDate"
                          locale="en"
                        ></b-form-datepicker
                      ></b-col>
                      <b-col>Testing Commenced Time</b-col>
                      <b-col
                        ><b-form-timepicker
                          v-model="LegionellaObject.TestCommencedTime"
                          locale="en"
                        ></b-form-timepicker
                      ></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Legionella MPN</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.MPN"
                      /></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="4">Test Result</b-col>
                      <b-col cols="4">
                        <b-select v-model="LegionellaObject.TestResult">
                          <option value="null" disabled
                            >Please Select Test Result</option
                          >
                          <option value="Pass">Pass</option>
                          <option value="Fail">Fail</option>
                        </b-select></b-col
                      >
                    </b-row>
                    <template #footer>
                      <b-row>
                        <b-col></b-col>
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="SubmitForm('Rapid', 'Legionella')"
                            >Submit</b-button
                          ></b-col
                        >
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="CancelForm('Rapid', 'Legionella')"
                            >Cancel</b-button
                          ></b-col
                        >
                        <b-col></b-col>
                      </b-row>
                    </template>
                  </b-card>
                </b-tab>
                <b-tab title="Pseudomonas" v-on:click="ChangeTab()" lazy>
                  <p>Choose Test to add results for:</p>
                  <b-table
                    sticky-header
                    no-border-collapse
                    responsive
                    :items="PseudomonasRapidForResults"
                    :fields="ForResultsFields"
                    hover
                    small
                    show-empty
                    empty-text="You dont have any Pseudomonas Tests waiting results"
                  >
                    <template v-slot:cell(Update)="{ item }">
                      <b-button
                        variant="outline-info"
                        v-on:click="AddResults(item, 'Rapid', 'Pseudomonas')"
                        size="sm"
                        >Update</b-button
                      >
                    </template>
                  </b-table>
                  <b-card v-if="this.ResultsInput == 'True'">
                    <b-row>
                      <b-col class="text-center"
                        ><h3>Rapid Results Upload</h3></b-col
                      >
                    </b-row>
                    <b-row>
                      <b-col class="text-center"><h3>Pseudomonas</h3></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col class="text-right">Completed By</b-col>
                      <b-col class="text-left">{{
                        this.PseudomonasObject.CompletedBy
                      }}</b-col>
                    </b-row>

                    <b-row>
                      <b-col>Test ID</b-col>
                      <b-col>{{ this.PseudomonasObject.TestID }}</b-col>
                      <b-col>Location Building</b-col>
                      <b-col>{{ this.PseudomonasObject.Location }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Number</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleID }} </b-col>
                      <b-col>Sample Location</b-col>
                      <b-col
                        >{{ this.PseudomonasObject.SampleLocation }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Date</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleDate }} </b-col>
                      <b-col>Sample Time</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleTime }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Outlet Type </b-col>
                      <b-col>{{ this.PseudomonasObject.OutletType }}</b-col>
                      <b-col>Post/Pre Flush</b-col>
                      <b-col>{{ this.PseudomonasObject.FlushType }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Description</b-col>
                      <b-col>{{ this.PseudomonasObject.Desc }}</b-col>
                      <b-col></b-col>
                      <b-col></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Testing Commenced Date</b-col>
                      <b-col
                        ><b-form-datepicker
                          v-model="PseudomonasObject.TestCommencedDate"
                          locale="en"
                        ></b-form-datepicker
                      ></b-col>
                      <b-col>Testing Commenced Time</b-col>
                      <b-col
                        ><b-form-timepicker
                          v-model="PseudomonasObject.TestCommencedTime"
                          locale="en"
                        ></b-form-timepicker
                      ></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Pseudomonas MPN</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.MPN"
                      /></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="4">Test Result</b-col>
                      <b-col cols="4">
                        <b-select v-model="PseudomonasObject.TestResult">
                          <option value="null" disabled
                            >Please Select Test Result</option
                          >
                          <option value="Pass">Pass</option>
                          <option value="Fail">Fail</option>
                        </b-select></b-col
                      >
                    </b-row>
                    <template #footer>
                      <b-row>
                        <b-col></b-col>
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="SubmitForm('Rapid', 'Pseudomonas')"
                            >Submit</b-button
                          ></b-col
                        >
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="CancelForm('Rapid', 'Pseudomonas')"
                            >Cancel</b-button
                          ></b-col
                        >
                        <b-col></b-col>
                      </b-row>
                    </template>
                  </b-card>
                </b-tab>
              </b-tabs>
            </b-card>
            <br />
          </div>
        </b-tab>

        <b-tab
          title="Check Colony Test Results"
          v-on:click="ChangeTab()"
          lazy
          v-if="this.UserAccess == 'TSA'"
        >
          <div>
            <br />

            <b-card v-if="this.UserAccess == 'TSA'">
              <br />
              <b-tabs>
                <b-tab title="Legionella" v-on:click="ChangeTab()" lazy>
                  <p>Choose Test to check results for:</p>
                  <b-table
                    sticky-header
                    no-border-collapse
                    responsive
                    :items="LegionellaColonyForInProg"
                    :fields="ForResultsFields"
                    hover
                    small
                    show-empty
                    empty-text="You dont have any Legionella Tests waiting results"
                  >
                    <template v-slot:cell(Update)="{ item }">
                      <b-button
                        variant="outline-info"
                        v-on:click="AddResults(item, 'Colony', 'Legionella')"
                        size="sm"
                        >Confirm Results</b-button
                      >
                    </template>
                  </b-table>
                  <br />
                  <b-card v-if="this.ResultsInput == 'True'">
                    <b-row>
                      <b-col class="text-center"
                        ><h3>Colony Results Check</h3></b-col
                      >
                    </b-row>
                    <b-row>
                      <b-col class="text-center"><h3>Legionella</h3></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col class="text-right">Completed By</b-col>
                      <b-col class="text-left">{{
                        this.LegionellaObject.CompletedBy
                      }}</b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Test ID</b-col>
                      <b-col>{{ this.LegionellaObject.TestID }}</b-col>
                      <b-col>Location Building</b-col>
                      <b-col>{{ this.LegionellaObject.Location }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Number</b-col>
                      <b-col>{{ this.LegionellaObject.SampleID }} </b-col>
                      <b-col>Sample Location</b-col>
                      <b-col>{{ this.LegionellaObject.SampleLocation }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Date</b-col>
                      <b-col>{{ this.LegionellaObject.SampleDate }} </b-col>
                      <b-col>Sample Time</b-col>
                      <b-col>{{ this.LegionellaObject.SampleTime }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Outlet Type </b-col>
                      <b-col>{{ this.LegionellaObject.OutletType }}</b-col>
                      <b-col>Post/Pre Flush</b-col>
                      <b-col>{{ this.LegionellaObject.FlushType }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Description</b-col>
                      <b-col>{{ this.LegionellaObject.Desc }}</b-col>
                      <b-col></b-col>
                      <b-col></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Testing Commenced Date</b-col>
                      <b-col
                        ><b-form-datepicker
                          v-model="LegionellaObject.TestCommencedDate"
                          locale="en"
                          readonly
                        ></b-form-datepicker
                      ></b-col>
                      <b-col>Testing Commenced Time</b-col>
                      <b-col
                        ><b-form-timepicker
                          v-model="LegionellaObject.TestCommencedTime"
                          locale="en"
                          readonly
                        ></b-form-timepicker
                      ></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Legionella cfu/1000ml MW28</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.LegVar1"
                          readonly
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Legionella pneumophila SG1 cfu/1000ml MW28</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.LegVar2"
                          readonly
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Legionella pneumophila SG2-14 cfu/1000ml MW28</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.LegVar3"
                          readonly
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Legionella species non pneumophila SG2-14 cfu/1000ml
                        MW28</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.LegVar4"
                          readonly
                      /></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="4">Test Result</b-col>
                      <b-col cols="4">
                        {{ LegionellaObject.TestResult }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <h5>Recommendations</h5>
                      </b-col>
                    </b-row>

                    <b-form-textarea
                      id="PSRecommendations"
                      v-model="LegionellaObject.Recommendations"
                      no-resize
                      placeholder="Please enter recommendations here. If no recommendations please complete with appropriate statement"
                      rows="3"
                      max-rows="3"
                    ></b-form-textarea>

                    <b-row>
                      <b-col>
                        <h5>Remedial Actions</h5>
                      </b-col>
                    </b-row>
                    <b-card no-body>
                      <b-card-body>
                        <b-row class="actionrow">
                          <b-col class="headercol">Action Type</b-col>
                          <b-col class="headercol">Description</b-col>
                          <!-- <b-col class="headercol">Outlet ID</b-col> -->
                          <b-col class="headercol">Due Date</b-col>
                          <b-col class="headercol">Responsibility</b-col>
                          <b-col class="headercol">Note</b-col>
                          <b-col cols="1" class="headercol"></b-col>
                        </b-row>
                        <b-row v-if="this.NewActionsList.length == 0">
                          <b-col class="text-center">No Current Actions</b-col>
                        </b-row>
                        <b-row
                          v-for="(NewAction, id) in this.NewActionsList"
                          :key="id"
                          class="actionrow"
                        >
                          <b-col class="bodycol">{{ NewAction.Type }}</b-col>
                          <b-col class="bodycol">{{
                            NewAction.Description
                          }}</b-col>
                          <!-- <b-col class="bodycol">{{
                            NewAction.OutletID
                          }}</b-col> -->
                          <b-col class="bodycol">{{
                            NewAction.Deadline
                          }}</b-col>
                          <b-col class="bodycol">{{
                            NewAction.Responsibility
                          }}</b-col>
                          <b-col class="bodycol">{{ NewAction.Note }}</b-col>
                          <b-col cols="1" class="bodycol"
                            ><b-button
                              variant="outline-danger"
                              size="sm"
                              v-on:click="removeAction(id)"
                              ><BIconXSquare></BIconXSquare></b-button
                          ></b-col>
                        </b-row>
                        <br />
                      </b-card-body>
                    </b-card>
                    <b-row>
                      <b-col
                        ><b-button
                          variant="outline-success"
                          size="sm"
                          v-on:click="addNewAction()"
                          ><BIconPlusSquare></BIconPlusSquare> New
                          Action</b-button
                        ></b-col
                      >
                    </b-row>
                    <template #footer>
                      <b-row>
                        <b-col></b-col>
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="
                              Submit4EyeCheckForm('Colony', 'Legionella')
                            "
                            >Submit</b-button
                          ></b-col
                        >
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="CancelForm('Colony', 'Legionella')"
                            >Cancel</b-button
                          ></b-col
                        >
                        <b-col></b-col>
                      </b-row>
                    </template>
                  </b-card>
                </b-tab>
                <b-tab title="Pseudomonas" v-on:click="ChangeTab()" lazy>
                  <p>Choose Test to check results for:</p>
                  <b-table
                    sticky-header
                    no-border-collapse
                    responsive
                    :items="PseudomonasColonyForInProg"
                    :fields="ForResultsFields"
                    hover
                    small
                    show-empty
                    empty-text="You dont have any Pseudomonas Tests waiting results"
                  >
                    <template v-slot:cell(Update)="{ item }">
                      <b-button
                        variant="outline-info"
                        v-on:click="AddResults(item, 'Colony', 'Pseudomonas')"
                        size="sm"
                        >Confirm Results</b-button
                      >
                    </template>
                  </b-table>
                  <br />
                  <b-card v-if="this.ResultsInput == 'True'">
                    <b-row>
                      <b-col class="text-center"
                        ><h3>Colony Results Check</h3></b-col
                      >
                    </b-row>
                    <b-row>
                      <b-col class="text-center"><h3>Pseudomonas</h3></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col class="text-right">Completed By</b-col>
                      <b-col class="text-left">{{
                        this.PseudomonasObject.CompletedBy
                      }}</b-col>
                    </b-row>
                    <!-- {{ this.PseudomonasObject }} -->
                    <b-row>
                      <b-col>Test ID</b-col>
                      <b-col>{{ this.PseudomonasObject.TestID }}</b-col>
                      <b-col>Location Building</b-col>
                      <b-col>{{ this.PseudomonasObject.Location }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Number</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleID }} </b-col>
                      <b-col>Sample Location</b-col>
                      <b-col
                        >{{ this.PseudomonasObject.SampleLocation }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Date</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleDate }} </b-col>
                      <b-col>Sample Time</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleTime }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Outlet Type </b-col>
                      <b-col>{{ this.PseudomonasObject.OutletType }}</b-col>
                      <b-col>Post/Pre Flush</b-col>
                      <b-col>{{ this.PseudomonasObject.FlushType }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Description</b-col>
                      <b-col>{{ this.PseudomonasObject.Desc }}</b-col>
                      <b-col></b-col>
                      <b-col></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Testing Commenced Date</b-col>
                      <b-col>
                        <!-- <b-form-datepicker
                          v-model="PseudomonasObject.TestCommencedDate"
                          locale="en"
                          readonly
                        ></b-form-datepicker> -->

                        {{ this.PseudomonasObject.TestCommencedDate }}
                      </b-col>
                      <b-col>Testing Commenced Time</b-col>
                      <b-col>
                        {{ this.PseudomonasObject.TestCommencedTime }}
                      </b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Aerobic Plate Count 37&#8451; [2 days] cfu/ml
                        MW3</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar1"
                          readonly
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Aerobic Plate Count 22&#8451; [3 days] cfu/ml
                        MW3</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar2"
                          readonly
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8"
                        >Pseudomonas aeruginosa cfu/100ml MW4</b-col
                      >
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar3"
                          readonly
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Total Coliforms cfu/100ml MW10</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar4"
                          readonly
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Escherichia coli cfu/100ml MW10</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar5"
                          readonly
                      /></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Pseudomonas 30&#8451; cfu/ml MW32</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.PseuVar6"
                          readonly
                      /></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="4">Test Result</b-col>
                      <b-col cols="4">
                        {{ PseudomonasObject.TestResult }}
                        <!-- <b-select v-model="PseudomonasObject.TestResult">
                          <option value="null" disabled
                            >Please Select Test Result</option
                          >
                          <option value="Pass" disabled>Pass</option>
                          <option value="Fail" disabled>Fail</option>
                        </b-select> -->
                      </b-col>
                    </b-row>
                    <!-- {{ this.PseudomonasObject }}

                    {{ this.NewActionsList }} -->
                    <b-row>
                      <b-col>
                        <h5>Recommendations</h5>
                      </b-col>
                    </b-row>

                    <b-form-textarea
                      id="PSRecommendations"
                      v-model="PseudomonasObject.Recommendations"
                      no-resize
                      placeholder="Please enter recommendations here. If no recommendations please complete with appropriate statement"
                      rows="3"
                      max-rows="3"
                    ></b-form-textarea>

                    <b-row>
                      <b-col>
                        <h5>Remedial Actions</h5>
                      </b-col>
                    </b-row>
                    <b-card no-body>
                      <b-card-body>
                        <b-row class="actionrow">
                          <b-col class="headercol">Action Type</b-col>
                          <b-col class="headercol">Description</b-col>
                          <b-col class="headercol">Outlet ID</b-col>
                          <b-col class="headercol">Due Date</b-col>
                          <b-col class="headercol">Responsibility</b-col>
                          <b-col class="headercol">Note</b-col>
                          <b-col cols="1" class="headercol"></b-col>
                        </b-row>
                        <b-row v-if="this.NewActionsList.length == 0">
                          <b-col class="text-center">No Current Actions</b-col>
                        </b-row>
                        <b-row
                          v-for="(NewAction, id) in this.NewActionsList"
                          :key="id"
                          class="actionrow"
                        >
                          <b-col class="bodycol">{{ NewAction.Type }}</b-col>
                          <b-col class="bodycol">{{
                            NewAction.Description
                          }}</b-col>
                          <!-- <b-col class="bodycol">{{
                            NewAction.OutletID
                          }}</b-col> -->
                          <b-col class="bodycol">{{
                            NewAction.Deadline
                          }}</b-col>
                          <b-col class="bodycol">{{
                            NewAction.Responsibility
                          }}</b-col>
                          <b-col class="bodycol">{{ NewAction.Note }}</b-col>
                          <b-col cols="1" class="bodycol"
                            ><b-button
                              variant="outline-danger"
                              size="sm"
                              v-on:click="removeAction(id)"
                              ><BIconXSquare></BIconXSquare></b-button
                          ></b-col>
                        </b-row>
                        <br />
                      </b-card-body>
                    </b-card>
                    <b-row>
                      <b-col
                        ><b-button
                          variant="outline-success"
                          size="sm"
                          v-on:click="addNewAction()"
                          ><BIconPlusSquare></BIconPlusSquare> New
                          Action</b-button
                        ></b-col
                      >
                    </b-row>
                    <template #footer>
                      <b-row>
                        <b-col></b-col>
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="
                              Submit4EyeCheckForm('Colony', 'Pseudomonas')
                            "
                            >Submit</b-button
                          ></b-col
                        >
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="CancelForm('Colony', 'Pseudomonas')"
                            >Cancel</b-button
                          ></b-col
                        >
                        <b-col></b-col>
                      </b-row>
                    </template>
                  </b-card>
                </b-tab>
              </b-tabs>
            </b-card>
            <br />
          </div>
        </b-tab>
        <b-tab
          title="Check Rapid Test Results"
          v-if="this.UserAccess == 'TSA'"
          v-on:click="ChangeTab()"
          lazy
        >
          <div>
            <br />

            <b-card v-if="this.UserAccess == 'TSA'">
              <br />
              <b-tabs>
                <b-tab title="Legionella" v-on:click="ChangeTab()" lazy>
                  <p>Choose Test to check results for:</p>
                  <b-table
                    sticky-header
                    no-border-collapse
                    responsive
                    :items="LegionellaRapidForInProg"
                    :fields="ForResultsFields"
                    hover
                    small
                    show-empty
                    empty-text="You dont have any Legionella Tests waiting results"
                  >
                    <template v-slot:cell(Update)="{ item }">
                      <b-button
                        variant="outline-info"
                        v-on:click="AddResults(item, 'Rapid', 'Legionella')"
                        size="sm"
                        >Confirm Results</b-button
                      >
                    </template>
                  </b-table>
                  <br />
                  <b-card v-if="this.ResultsInput == 'True'">
                    <b-row>
                      <b-col class="text-center"
                        ><h3>Rapid Results Upload</h3></b-col
                      >
                    </b-row>
                    <b-row>
                      <b-col class="text-center"><h3>Legionella</h3></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col class="text-right">Completed By</b-col>
                      <b-col class="text-left">{{
                        this.LegionellaObject.CompletedBy
                      }}</b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Test ID</b-col>
                      <b-col>{{ this.LegionellaObject.TestID }}</b-col>
                      <b-col>Location Building</b-col>
                      <b-col>{{ this.LegionellaObject.Location }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Number</b-col>
                      <b-col>{{ this.LegionellaObject.SampleID }} </b-col>
                      <b-col>Sample Location</b-col>
                      <b-col>{{ this.LegionellaObject.SampleLocation }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Date</b-col>
                      <b-col>{{ this.LegionellaObject.SampleDate }} </b-col>
                      <b-col>Sample Time</b-col>
                      <b-col>{{ this.LegionellaObject.SampleTime }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Outlet Type </b-col>
                      <b-col>{{ this.LegionellaObject.OutletType }}</b-col>
                      <b-col>Post/Pre Flush</b-col>
                      <b-col>{{ this.LegionellaObject.FlushType }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Description</b-col>
                      <b-col>{{ this.LegionellaObject.Desc }}</b-col>
                      <b-col></b-col>
                      <b-col></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Testing Commenced Date</b-col>
                      <b-col
                        ><b-form-datepicker
                          v-model="LegionellaObject.TestCommencedDate"
                          locale="en"
                          readonly
                        ></b-form-datepicker
                      ></b-col>
                      <b-col>Testing Commenced Time</b-col>
                      <b-col
                        ><b-form-timepicker
                          v-model="LegionellaObject.TestCommencedTime"
                          locale="en"
                          readonly
                        ></b-form-timepicker
                      ></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Legionella MPN</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="LegionellaObject.MPN"
                          readonly
                      /></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="4">Test Result</b-col>
                      <b-col cols="4">
                        {{ LegionellaObject.TestResult }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <h5>Recommendations</h5>
                      </b-col>
                    </b-row>

                    <b-form-textarea
                      id="PSRecommendations"
                      v-model="LegionellaObject.Recommendations"
                      no-resize
                      placeholder="Please enter recommendations here. If no recommendations please complete with appropriate statement"
                      rows="3"
                      max-rows="3"
                    ></b-form-textarea>

                    <b-row>
                      <b-col>
                        <h5>Remedial Actions</h5>
                      </b-col>
                    </b-row>
                    <b-card no-body>
                      <b-card-body>
                        <b-row class="actionrow">
                          <b-col class="headercol">Action Type</b-col>
                          <b-col class="headercol">Description</b-col>
                          <!-- <b-col class="headercol">Outlet ID</b-col> -->
                          <b-col class="headercol">Due Date</b-col>
                          <b-col class="headercol">Responsibility</b-col>
                          <b-col class="headercol">Note</b-col>
                          <b-col cols="1" class="headercol"></b-col>
                        </b-row>
                        <b-row v-if="this.NewActionsList.length == 0">
                          <b-col class="text-center">No Current Actions</b-col>
                        </b-row>
                        <b-row
                          v-for="(NewAction, id) in this.NewActionsList"
                          :key="id"
                          class="actionrow"
                        >
                          <b-col class="bodycol">{{ NewAction.Type }}</b-col>
                          <b-col class="bodycol">{{
                            NewAction.Description
                          }}</b-col>
                          <!-- <b-col class="bodycol">{{
                            NewAction.OutletID
                          }}</b-col> -->
                          <b-col class="bodycol">{{
                            NewAction.Deadline
                          }}</b-col>
                          <b-col class="bodycol">{{
                            NewAction.Responsibility
                          }}</b-col>
                          <b-col class="bodycol">{{ NewAction.Note }}</b-col>
                          <b-col cols="1" class="bodycol"
                            ><b-button
                              variant="outline-danger"
                              size="sm"
                              v-on:click="removeAction(id)"
                              ><BIconXSquare></BIconXSquare></b-button
                          ></b-col>
                        </b-row>
                        <br />
                      </b-card-body>
                    </b-card>
                    <b-row>
                      <b-col
                        ><b-button
                          variant="outline-success"
                          size="sm"
                          v-on:click="addNewAction()"
                          ><BIconPlusSquare></BIconPlusSquare> New
                          Action</b-button
                        ></b-col
                      >
                    </b-row>
                    <template #footer>
                      <b-row>
                        <b-col></b-col>
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="
                              Submit4EyeCheckForm('Rapid', 'Legionella')
                            "
                            >Submit</b-button
                          ></b-col
                        >
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="CancelForm('Rapid', 'Legionella')"
                            >Cancel</b-button
                          ></b-col
                        >
                        <b-col></b-col>
                      </b-row>
                    </template>
                  </b-card>
                </b-tab>
                <b-tab title="Pseudomonas" v-on:click="ChangeTab()" lazy>
                  <p>Choose Test to check results for:</p>
                  <b-table
                    sticky-header
                    no-border-collapse
                    responsive
                    :items="PseudomonasRapidForInProg"
                    :fields="ForResultsFields"
                    hover
                    small
                    show-empty
                    empty-text="You dont have any Pseudomonas Tests waiting results"
                  >
                    <template v-slot:cell(Update)="{ item }">
                      <b-button
                        variant="outline-info"
                        v-on:click="AddResults(item, 'Rapid', 'Pseudomonas')"
                        size="sm"
                        >Confirm Results</b-button
                      >
                    </template>
                  </b-table>
                  <br />
                  <b-card v-if="this.ResultsInput == 'True'">
                    <b-row>
                      <b-col class="text-center"
                        ><h3>Rapid Results Upload</h3></b-col
                      >
                    </b-row>

                    <b-row>
                      <b-col class="text-center"><h3>Pseudomonas</h3></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col class="text-right">Completed By</b-col>
                      <b-col class="text-left">{{
                        this.PseudomonasObject.CompletedBy
                      }}</b-col>
                    </b-row>

                    <b-row>
                      <b-col>Test ID</b-col>
                      <b-col>{{ this.PseudomonasObject.TestID }}</b-col>
                      <b-col>Location Building</b-col>
                      <b-col>{{ this.PseudomonasObject.Location }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Number</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleID }} </b-col>
                      <b-col>Sample Location</b-col>
                      <b-col
                        >{{ this.PseudomonasObject.SampleLocation }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Sample Date</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleDate }} </b-col>
                      <b-col>Sample Time</b-col>
                      <b-col>{{ this.PseudomonasObject.SampleTime }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col>Outlet Type </b-col>
                      <b-col>{{ this.PseudomonasObject.OutletType }}</b-col>
                      <b-col>Post/Pre Flush</b-col>
                      <b-col>{{ this.PseudomonasObject.FlushType }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Description</b-col>
                      <b-col>{{ this.PseudomonasObject.Desc }}</b-col>
                      <b-col></b-col>
                      <b-col></b-col>
                    </b-row>
                    <br />
                    <b-row>
                      <b-col>Testing Commenced Date</b-col>
                      <b-col
                        ><b-form-datepicker
                          v-model="PseudomonasObject.TestCommencedDate"
                          locale="en"
                        ></b-form-datepicker
                      ></b-col>
                      <b-col>Testing Commenced Time</b-col>
                      <b-col
                        ><b-form-timepicker
                          v-model="PseudomonasObject.TestCommencedTime"
                          locale="en"
                        ></b-form-timepicker
                      ></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="1"><BIconStopFill></BIconStopFill></b-col>
                      <b-col cols="8">Pseudomonas MPN</b-col>
                      <b-col cols="3"
                        ><input
                          type="text"
                          placeholder="Enter Count"
                          v-model="PseudomonasObject.MPN"
                          readonly
                      /></b-col>
                    </b-row>
                    <hr />
                    <b-row>
                      <b-col cols="4">Test Result</b-col>
                      <b-col cols="4">
                        <!-- <b-select v-model="PseudomonasObject.TestResult">
                          <option value="null" disabled
                            >Please Select Test Result</option
                          >
                          <option value="Pass">Pass</option>
                          <option value="Fail">Fail</option>
                        </b-select> -->
                        {{ PseudomonasObject.TestResult }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <h5>Recommendations</h5>
                      </b-col>
                    </b-row>

                    <b-form-textarea
                      id="PSRecommendations"
                      v-model="PseudomonasObject.Recommendations"
                      no-resize
                      placeholder="Please enter recommendations here. If no recommendations please complete with appropriate statement"
                      rows="3"
                      max-rows="3"
                    ></b-form-textarea>

                    <b-row>
                      <b-col>
                        <h5>Remedial Actions</h5>
                      </b-col>
                    </b-row>
                    <b-card no-body>
                      <b-card-body>
                        <b-row class="actionrow">
                          <b-col class="headercol">Action Type</b-col>
                          <b-col class="headercol">Description</b-col>
                          <!-- <b-col class="headercol">Outlet ID</b-col> -->
                          <b-col class="headercol">Due Date</b-col>
                          <b-col class="headercol">Responsibility</b-col>
                          <b-col class="headercol">Note</b-col>
                          <b-col cols="1" class="headercol"></b-col>
                        </b-row>
                        <b-row v-if="this.NewActionsList.length == 0">
                          <b-col class="text-center">No Current Actions</b-col>
                        </b-row>
                        <b-row
                          v-for="(NewAction, id) in this.NewActionsList"
                          :key="id"
                          class="actionrow"
                        >
                          <b-col class="bodycol">{{ NewAction.Type }}</b-col>
                          <b-col class="bodycol">{{
                            NewAction.Description
                          }}</b-col>
                          <!-- <b-col class="bodycol">{{
                            NewAction.OutletID
                          }}</b-col> -->
                          <b-col class="bodycol">{{
                            NewAction.Deadline
                          }}</b-col>
                          <b-col class="bodycol">{{
                            NewAction.Responsibility
                          }}</b-col>
                          <b-col class="bodycol">{{ NewAction.Note }}</b-col>
                          <b-col cols="1" class="bodycol"
                            ><b-button
                              variant="outline-danger"
                              size="sm"
                              v-on:click="removeAction(id)"
                              ><BIconXSquare></BIconXSquare></b-button
                          ></b-col>
                        </b-row>
                        <br />
                      </b-card-body>
                    </b-card>
                    <b-row>
                      <b-col
                        ><b-button
                          variant="outline-success"
                          size="sm"
                          v-on:click="addNewAction()"
                          ><BIconPlusSquare></BIconPlusSquare> New
                          Action</b-button
                        ></b-col
                      >
                    </b-row>
                    <template #footer>
                      <b-row>
                        <b-col></b-col>
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="
                              Submit4EyeCheckForm('Rapid', 'Pseudomonas')
                            "
                            >Submit</b-button
                          ></b-col
                        >
                        <b-col
                          ><b-button
                            size="sm"
                            variant="outline-info"
                            v-on:click="CancelForm('Rapid', 'Pseudomonas')"
                            >Cancel</b-button
                          ></b-col
                        >
                        <b-col></b-col>
                      </b-row>
                    </template>
                  </b-card>
                </b-tab>
              </b-tabs>
            </b-card>
            <br />
          </div>
        </b-tab>
        <b-tab
          title="Previous Results"
          v-on:click="ChangeTab()"
          v-if="this.UserAccess == 'TSA'"
        >
          <br />
          <b-card title="Previous Results">
            <b-table
              sticky-header
              no-border-collapse
              responsive
              :items="CompletedTestsItems"
              :fields="CompletedTestsFields"
              hover
              small
              show-empty
              empty-text="You dont have any previous test results"
            >
              <template v-slot:cell(TestResult)="{ item }">
                <b-avatar
                  v-if="item.TestResult === 'Pass'"
                  variant="success"
                  rounded
                  size="2em"
                  >P
                </b-avatar>
                <b-avatar
                  v-if="item.TestResult === 'Fail'"
                  variant="danger"
                  rounded
                  size="2em"
                  >F
                </b-avatar>
              </template>
              <template v-slot:cell(View)="{ item }">
                <b-button
                  variant="outline-info"
                  v-on:click="showCompleteDetails(item)"
                  size="sm"
                  >View</b-button
                >
              </template>
            </b-table>
          </b-card>
          <br />
        </b-tab>
      </b-tabs>
    </b-card>
    <b-modal
      ref="TestResultsModal"
      id="TestResultsModal"
      title="Test Result Notes"
      content-class="Modal"
      :header-variant="OverallColour"
      v-model="modalShowing"
    >
      <h4>Test ID: {{ this.modalItem[0] }}</h4>
      <h5>Outlet ID: {{ this.modalDetails[4] }}</h5>

      <!-- {{ this.modalDetails }} -->
      <b-card :header-bg-variant="this.OverallColour">
        <template #header>
          <h6>Test Outcome - {{ TestResult }}</h6>
        </template>
        <b-row
          ><b-col>
            <label class="boldLabel">Test </label>
          </b-col>
          <b-col>
            <label class="boldLabel">Location </label>
          </b-col>
        </b-row>
        <b-row>
          <b-col>{{ this.modalDetails[0] }}</b-col>
          <b-col>{{ this.modalDetails[1] }}</b-col>
        </b-row>
        <br />
        <b-row>
          <b-col><label class="boldLabel">Flush Type</label></b-col>
          <b-col><label class="boldLabel">Outlet Type</label></b-col>
        </b-row>

        <b-row>
          <b-col>{{ this.modalDetails[2] }}</b-col>
          <b-col>{{ this.modalDetails[3] }}</b-col>
        </b-row>
        <br />
        <b-row>
          <b-col><label class="boldLabel">Sample Date</label></b-col>
          <b-col><label class="boldLabel">Sample Time</label></b-col>
        </b-row>

        <b-row>
          <b-col>{{ this.modalDetails[5] }}</b-col>
          <b-col>{{ this.modalDetails[6] }}</b-col>
        </b-row>
        <br />
        <b-row>
          <b-col><label class="boldLabel">Test Commenced Date</label></b-col>
          <b-col><label class="boldLabel">Test Commenced Time</label></b-col>
        </b-row>

        <b-row>
          <b-col>{{ this.modalDetails[10] }}</b-col>
          <b-col>{{ this.modalDetails[11] }}</b-col>
        </b-row>

        <template #footer v-if="this.modalDetails[8] == 'Completed'">
          <b-card>
            <b-row>
              <b-col class="text-center">
                <b-button
                  v-on:click="showDetailsColony()"
                  size="sm"
                  variant="outline-secondary"
                  ><BIconListUl></BIconListUl> Show Details</b-button
                ></b-col
              >
            </b-row>
            <template #footer> </template>
          </b-card>
        </template>
      </b-card>
    </b-modal>
    <b-modal
      size="xl"
      header-bg-variant="dark"
      header-text-variant="light"
      ref="ColonyDetail"
      id="ColonyDetail"
      :title="'Test ' + modalItem[0]"
    >
      <b-card :header-bg-variant="OverallColour">
        <template #header> Test Result - {{ ColonyDetails[7] }} </template>
        <b-row>
          <b-col><label class="boldLabel">Test Type</label></b-col>
          <b-col><label class="boldLabel">Outlet Details</label></b-col>
        </b-row>

        <b-row>
          <b-col>{{ this.ColonyDetails[0] }}</b-col>
          <b-col>{{
            this.ColonyDetails[3] + " - " + this.ColonyDetails[4]
          }}</b-col>
        </b-row>
        <hr />

        <!-- DO THE THING -->
        <section
          v-if="
            (this.ColonyDetails[0] == 'Legionella' ||
              this.ColonyDetails[0] == 'Both') &
              (this.TestVariant == 'Rapid')
          "
        >
          <b-row>
            <b-col><label class="boldLabel">Legionella MPN</label></b-col>
            <b-col><label class="boldLabel">Legionella Result</label></b-col>
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[12] }}</b-col>
            <b-col>{{ this.ColonyDetails[13] }}</b-col>
          </b-row>
          <br />
        </section>
        <section
          v-if="
            (this.ColonyDetails[0] == 'Pseudomonas' ||
              this.ColonyDetails[0] == 'Both') &
              (this.TestVariant == 'Colony')
          "
        >
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Aerobic Plate Count 37°C [2 days] cfu/ml MW3</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Aerobic Plate Count 22°C [3 days] cfu/ml MW3</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[16] }}</b-col>
            <b-col>{{ this.ColonyDetails[17] }}</b-col>
          </b-row>

          <br />
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Pseudomonas aeruginosa cfu/100 ml MW4</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Total Coliforms cfu/100 ml MW10</label
              ></b-col
            >
          </b-row>
          <b-row>
            <b-col>{{ this.ColonyDetails[18] }}</b-col>
            <b-col>{{ this.ColonyDetails[19] }}</b-col>
          </b-row>
          <br />
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Escherichia coli cfu/100 ml MW10</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Pseudomonas 30 °C cfu/ml MW32</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[20] }}</b-col>
            <b-col>{{ this.ColonyDetails[21] }}</b-col>
          </b-row>
          <br />
        </section>
        <section
          v-if="
            (this.ColonyDetails[0] == 'Pseudomonas' ||
              this.ColonyDetails[0] == 'Both') &
              (this.TestVariant == 'Rapid')
          "
        >
          <b-row>
            <b-col><label class="boldLabel">Pseudomonas MPN</label></b-col>
            <b-col><label class="boldLabel">Pseudomonas Result</label></b-col>
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[14] }}</b-col>
            <b-col>{{ this.ColonyDetails[15] }}</b-col>
          </b-row>
          <br />
        </section>
        <!-- completed from here?-->
        <section
          v-if="
            (this.ColonyDetails[0] == 'Legionella' ||
              this.ColonyDetails[0] == 'Both') &
              (this.ColonyDetails[8] == 'Completed') &
              (this.TestVariant == 'Colony')
          "
        >
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Legionella cfu/1000ml MW28</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Legionella pneumophila SG 1 cfu/1000 ml MW28</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[12] }}</b-col>
            <b-col>{{ this.ColonyDetails[13] }}</b-col>
          </b-row>

          <br />
          <b-row>
            <b-col
              ><label class="boldLabel"
                >Legionella pneumophila SG 2-14 cfu/1000 ml MW28</label
              ></b-col
            >
            <b-col
              ><label class="boldLabel"
                >Legionella species non pneumophila cfu/1000 ml MW28</label
              ></b-col
            >
          </b-row>

          <b-row>
            <b-col>{{ this.ColonyDetails[14] }}</b-col>
            <b-col>{{ this.ColonyDetails[15] }}</b-col>
          </b-row>
          <br />
        </section>
      </b-card>
    </b-modal>
    <b-modal
      ref="AddActionModal"
      id="AddActionModal"
      title="Remedial Action"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      hide-footer
    >
      <b-card>
        <div>
          <!-- <b-row>
            <b-col cols="4" class="text-left">Risk Assessment</b-col>
            <b-col cols="8">{{ NewAction.RiskAssessment }}</b-col>
          </b-row> -->
          <br />
          <b-row>
            <b-col cols="4" class="text-left">Action Type</b-col>
            <b-col cols="8"
              ><input type="text" v-model="NewAction.Type"
            /></b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="4" class="text-left">Due Date </b-col>
            <b-col cols="8"
              ><b-form-datepicker
                v-model="NewAction.Deadline"
              ></b-form-datepicker>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="4" class="text-left">Responsibility </b-col>
            <b-col cols="8"
              ><input type="text" v-model="NewAction.Responsibility"
            /></b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="4" class="text-left">Description</b-col>
            <b-col cols="8"
              ><input type="text" v-model="NewAction.Description"
            /></b-col>
          </b-row>
          <br />
          <!-- <b-row>
            <b-col cols="4" class="text-left">Outlet ID</b-col>
            <b-col cols="8"
              ><input type="text" v-model="NewAction.OutletID"
            /></b-col>
          </b-row>
          <br /> -->
          <b-row>
            <b-col cols="4" class="text-left">Note </b-col>
            <b-col cols="8"
              ><input type="text" v-model="NewAction.Note"
            /></b-col>
          </b-row>
          <br />
          <b-row
            ><b-col
              ><b-button
                size="sm"
                variant="outline-info"
                v-on:click="SubmitActionModal()"
                >Save Action</b-button
              ></b-col
            >
            <b-col
              ><b-button
                size="sm"
                variant="outline-info"
                v-on:click="CancelActionModal()"
                >Cancel Action</b-button
              ></b-col
            ></b-row
          >
        </div>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import {
  BIconStopFill,
  BIconListUl,
  BIconPlusSquare,
  BIconXSquare,
} from "bootstrap-vue";

import axios from "axios";
import Vue from "vue";

export default {
  computed: {},
  components: {
    BIconStopFill,
    BIconListUl,
    BIconPlusSquare,
    BIconXSquare,
  },

  data() {
    return {
      NewAction: {
        Type: null,
        Description: null,
        Deadline: null,
        Responsibility: null,
        RiskAssessment: null,
        Note: null,
      },
      NewActionsList: [],
      ActionListFields: [
        { key: "Type", label: "Action Type", variant: "primary" },
        { key: "Description", label: "Description" },
        { key: "OutletID", label: "Outlet ID" },
        { key: "Deadline", label: "Due Date" },
        { key: "Responsibility", label: "Responsibility" },
        // { key: "RiskAssessment", label: "Risk Assessment" },
        { key: "Note", label: "Note" },
        { key: "Action", label: "" },
      ],
      UserAccess: localStorage.getItem("accessGroup"),
      selectedlocation: localStorage.getItem("CurrentLocation"),
      company: localStorage.getItem("Company"),
      LegionellaColonyForResults: [],
      PseudomonasColonyForResults: [],
      LegionellaRapidForResults: [],
      PseudomonasRapidForResults: [],

      ForResultsFields: [
        { key: "TestID", label: "Test ID", variant: "primary" },
        { key: "SampleID", label: "Sample ID" },
        { key: "SampleDate", label: "Sample Date" },
        { key: "SampleTime", label: "Sample Time" },
        { key: "SampleLocation", label: "Sample Location" },
        { key: "Desc", label: "Desc" },
        { key: "FlushType", Label: "Pre/Post Flush" },
        { key: "OutletType", Label: "Outlet" },
        { key: "Update", label: "Update" },
      ],
      ResultsInput: "False",
      LegionellaObject: {
        TestID: null,
        Location: null,
        CompletedBy: null,
        SampleID: null,
        SampleDate: null,
        SampleTime: null,
        SampleLocation: null,
        Desc: null,
        OutletType: null,
        FlushType: null,
        TestCommencedTime: null,
        TestCommencedDate: null,
        LegVar1: "Not Detected",
        LegVar2: "Not Detected",
        LegVar3: "Not Detected",
        LegVar4: "Not Detected",
        TestResult: null,
        MPN: "Not Detected",
      },
      PseudomonasObject: {
        TestID: null,
        Location: null,
        CompletedBy: null,
        SampleID: null,
        SampleDate: null,
        SampleTime: null,
        SampleLocation: null,
        Desc: null,
        OutletType: null,
        FlushType: null,
        TestCommencedTime: null,
        TestCommencedDate: null,
        PseuVar1: "Not Detected",
        PseuVar2: "Not Detected",
        PseuVar3: "Not Detected",
        PseuVar4: "Not Detected",
        PseuVar5: "Not Detected",
        PseuVar6: "Not Detected",
        TestResult: null,
        MPN: "Not Detected",
      },
      ModalVar: null,
      CompletedTestsItems: [],
      CompletedTestsFields: [
        { key: "TestID", label: "Test ID", variant: "primary" },
        { key: "TestVariant", label: "Test Variant" },
        { key: "TestType", label: "Test Type" },
        { key: "TestDesc", label: "Test Desc" },
        { key: "SampleDate", label: "Sample Date" },
        { key: "TestResult", label: "Test Result" },
        { key: "View", label: "View" },
      ],
      modalShowing: null,
      modalItem: [],
      modalDetails: [],
      ColonyDetails: "",
      OverallColour: "",
      TestResult: "",
      TestVariant: "",
      LegionellaColonyArray: [],
      PseudomonasColonyArray: [],
      LegionellaRapidArray: [],
      PseudomonasRapidArray: [],
      LegionellaColonyForInProg: [],
      PseudomonasColonyForInProg: [],
      LegionellaRapidForInProg: [],
      PseudomonasRapidForInProg: [],
    };
  },

  mounted() {
    let LookUpURLNewTests =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersNewTests = this.$apikeyPost;
    let LookUpRequestNewTests = {
      ServiceType: "WaterTesting",
      RequestType: "NewTests",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(LookUpURLNewTests, LookUpRequestNewTests, LookUpHeadersNewTests)
      .then((response) => {
        this.LegionellaColonyArray = response.data.NewCFULegionella;
        this.PseudomonasColonyArray = response.data.NewCFUPseudomonas;
        this.LegionellaRapidArray = response.data.NewRapidLegionella;
        this.PseudomonasRapidArray = response.data.NewRapidPseudomonas;

        for (let i = 0; i < this.LegionellaColonyArray.length; i++) {
          this.LegionellaColonyForResults.push({
            TestID: this.LegionellaColonyArray[i][0],
            SampleID: this.LegionellaColonyArray[i][1],
            SampleDate: this.LegionellaColonyArray[i][2],
            SampleTime: this.LegionellaColonyArray[i][3],
            SampleLocation: this.LegionellaColonyArray[i][4],
            Desc: this.LegionellaColonyArray[i][5],
            FlushType: this.LegionellaColonyArray[i][6],
            OutletType: this.LegionellaColonyArray[i][7],
            Update: null,
          });
        }

        for (let i = 0; i < this.PseudomonasColonyArray.length; i++) {
          this.PseudomonasColonyForResults.push({
            TestID: this.PseudomonasColonyArray[i][0],
            SampleID: this.PseudomonasColonyArray[i][1],
            SampleDate: this.PseudomonasColonyArray[i][2],
            SampleTime: this.PseudomonasColonyArray[i][3],
            SampleLocation: this.PseudomonasColonyArray[i][4],
            Desc: this.PseudomonasColonyArray[i][5],
            FlushType: this.PseudomonasColonyArray[i][6],
            OutletType: this.PseudomonasColonyArray[i][7],
            Update: null,
          });
        }

        for (let i = 0; i < this.LegionellaRapidArray.length; i++) {
          this.LegionellaRapidForResults.push({
            TestID: this.LegionellaRapidArray[i][0],
            SampleID: this.LegionellaRapidArray[i][1],
            SampleDate: this.LegionellaRapidArray[i][2],
            SampleTime: this.LegionellaRapidArray[i][3],
            SampleLocation: this.LegionellaRapidArray[i][4],
            Desc: this.LegionellaRapidArray[i][5],
            FlushType: this.LegionellaRapidArray[i][6],
            OutletType: this.LegionellaRapidArray[i][7],
            Update: null,
          });
        }

        for (let i = 0; i < this.PseudomonasRapidArray.length; i++) {
          this.PseudomonasRapidForResults.push({
            TestID: this.PseudomonasRapidArray[i][0],
            SampleID: this.PseudomonasRapidArray[i][1],
            SampleDate: this.PseudomonasRapidArray[i][2],
            SampleTime: this.PseudomonasRapidArray[i][3],
            SampleLocation: this.PseudomonasRapidArray[i][4],
            Desc: this.PseudomonasRapidArray[i][5],
            FlushType: this.PseudomonasRapidArray[i][6],
            OutletType: this.PseudomonasRapidArray[i][7],
            Update: null,
          });
        }
      });

    let LookUpURLCompletedTests =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersCompletedTests = this.$apikeyPost;
    let LookUpRequestCompletedTests = {
      ServiceType: "WaterTesting",
      RequestType: "CompletedTests",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpURLCompletedTests,
        LookUpRequestCompletedTests,
        LookUpHeadersCompletedTests
      )
      .then((response) => {
        this.CompletedTestArray = response.data.Values;

        for (let i = 0; i < this.CompletedTestArray.length; i++) {
          this.CompletedTestsItems.push({
            TestID: this.CompletedTestArray[i][0],
            TestType: this.CompletedTestArray[i][1],
            TestDesc: this.CompletedTestArray[i][3],
            SampleDate: this.CompletedTestArray[i][4],
            TestResult: this.CompletedTestArray[i][5],
            TestStatus: this.CompletedTestArray[i][6],
            TestVariant: this.CompletedTestArray[i][2],
          });
        }
      });

    let LookUpURLInProgTests =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersInProgTests = this.$apikeyPost;
    let LookUpRequestInProgTests = {
      ServiceType: "WaterTesting",
      RequestType: "InProgressTests",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(
        LookUpURLInProgTests,
        LookUpRequestInProgTests,
        LookUpHeadersInProgTests
      )
      .then((response) => {
        (this.LegionellaColonyForInProg = []),
          (this.PseudomonasColonyForInProg = []),
          (this.LegionellaRapidForInProg = []);
        this.PseudomonasRapidForInProg = [];

        let legionellaColArr = response.data.InProgCFULegionella;
        let legionellaRapidArr = response.data.InProgRapidLegionella;
        let PseudomonasColArr = response.data.InProgCFUPseudomonas;
        let PseudomonasRapidArr = response.data.InProgRapidPseudomonas;

        for (let i = 0; i < legionellaColArr.length; i++) {
          this.LegionellaColonyForInProg.push({
            TestID: legionellaColArr[i][0],
            SampleID: legionellaColArr[i][1],
            SampleDate: legionellaColArr[i][2],
            SampleTime: legionellaColArr[i][3],
            SampleLocation: legionellaColArr[i][4],
            Desc: legionellaColArr[i][5],
            FlushType: legionellaColArr[i][6],
            OutletType: legionellaColArr[i][7],
            Update: null,
          });
        }

        for (let i = 0; i < PseudomonasColArr.length; i++) {
          this.PseudomonasColonyForInProg.push({
            TestID: PseudomonasColArr[i][0],
            SampleID: PseudomonasColArr[i][1],
            SampleDate: PseudomonasColArr[i][2],
            SampleTime: PseudomonasColArr[i][3],
            SampleLocation: PseudomonasColArr[i][4],
            Desc: PseudomonasColArr[i][5],
            FlushType: PseudomonasColArr[i][6],
            OutletType: PseudomonasColArr[i][7],
            Update: null,
          });
        }

        for (let i = 0; i < legionellaRapidArr.length; i++) {
          this.LegionellaRapidForInProg.push({
            TestID: legionellaRapidArr[i][0],
            SampleID: legionellaRapidArr[i][1],
            SampleDate: legionellaRapidArr[i][2],
            SampleTime: legionellaRapidArr[i][3],
            SampleLocation: legionellaRapidArr[i][4],
            Desc: legionellaRapidArr[i][5],
            FlushType: legionellaRapidArr[i][6],
            OutletType: legionellaRapidArr[i][7],
            Update: null,
          });
        }

        for (let i = 0; i < PseudomonasRapidArr.length; i++) {
          this.PseudomonasRapidForInProg.push({
            TestID: PseudomonasRapidArr[i][0],
            SampleID: PseudomonasRapidArr[i][1],
            SampleDate: PseudomonasRapidArr[i][2],
            SampleTime: PseudomonasRapidArr[i][3],
            SampleLocation: PseudomonasRapidArr[i][4],
            Desc: PseudomonasRapidArr[i][5],
            FlushType: PseudomonasRapidArr[i][6],
            OutletType: PseudomonasRapidArr[i][7],
            Update: null,
          });
        }
      });
  },
  methods: {
    addNewAction() {
      (this.NewAction = {
        Type: null,
        Description: null,
        Deadline: null,
        Responsibility: null,
        RiskAssessment: this.LinkedRiskAssessment,
        Note: null,
      }),
        this.$refs["AddActionModal"].show();
    },
    CancelActionModal() {
      this.$refs["AddActionModal"].hide();
    },
    SubmitActionModal() {
      this.NewActionsList.push(this.NewAction);

      alert("Action Added to List");
      this.$refs["AddActionModal"].hide();
      this.NewAction = {
        Type: null,
        Description: null,
        Deadline: null,
        Responsibility: null,
        RiskAssessment: this.LinkedRiskAssessment,
        Note: null,
      };
    },
    removeAction(item) {
      this.NewActionsList.splice(item, 1);
      alert("Action Removed");
    },
    FormatDate(date) {
      if (date == null) {
        return;
      }
      if (date.includes("-")) {
        return date;
      } else {
        let dt1 = parseInt(date.substring(0, 2));
        let mon1 = parseInt(date.substring(3, 5));
        let yr1 = parseInt(date.substring(6, 10));
        let dbformatdate = yr1 + "-" + mon1 + "-" + dt1;
        return dbformatdate;
      }
    },

    AddResults(item, Type, Variant) {
      this.ResultsInput = "True";
      this.NewActionsList = [];
      if (Type == "Colony" && Variant == "Legionella") {
        let LookUpURLInProgTests =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let LookUpHeadersInProgTests = this.$apikeyPost;
        let LookUpRequestInProgTests = {
          ServiceType: "WaterTesting",
          RequestType: "CFUTestDetails",
          DataDict: [
            {
              TestID: item.TestID,
            },
          ],
        };
        axios
          .post(
            LookUpURLInProgTests,
            LookUpRequestInProgTests,
            LookUpHeadersInProgTests
          )
          .then((response) => {
            this.LegionellaObject.TestResult = response.data.Values[0][7];
            (this.LegionellaObject.TestID = item.TestID),
              (this.LegionellaObject.Location = this.selectedlocation),
              (this.LegionellaObject.CompletedBy = this.company);
            (this.LegionellaObject.SampleID = item.SampleID),
              (this.LegionellaObject.SampleLocation = item.SampleLocation),
              (this.LegionellaObject.SampleDate = item.SampleDate),
              (this.LegionellaObject.SampleTime = item.SampleTime),
              (this.LegionellaObject.OutletType = item.OutletType),
              (this.LegionellaObject.FlushType = item.FlushType),
              (this.LegionellaObject.Desc = item.Desc);
            (this.LegionellaObject.TestCommencedDate = this.FormatDate(
              response.data.Values[0][10]
            )),
              (this.LegionellaObject.TestCommencedTime =
                response.data.Values[0][11]);
            this.LegionellaObject.LegVar1 = response.data.Values[0][12];
            this.LegionellaObject.LegVar2 = response.data.Values[0][13];

            this.LegionellaObject.LegVar3 = response.data.Values[0][14];

            this.LegionellaObject.LegVar4 = response.data.Values[0][15];
          });
      } else if (Type == "Colony" && Variant == "Pseudomonas") {
        // (this.PseudomonasObject.TestID = item.TestID),
        //   (this.PseudomonasObject.Location = this.selectedlocation),
        //   (this.PseudomonasObject.CompletedBy = this.company),
        //   (this.PseudomonasObject.SampleID = item.SampleID),
        //   (this.PseudomonasObject.SampleLocation = item.SampleLocation),
        //   (this.PseudomonasObject.SampleDate = item.SampleDate),
        //   (this.PseudomonasObject.SampleTime = item.SampleTime),
        //   (this.PseudomonasObject.OutletType = item.OutletType),
        //   (this.PseudomonasObject.FlushType = item.FlushType),
        //   (this.PseudomonasObject.Desc = item.Desc);
        // this.PseudomonasObject.TestResult = item.TestResult;

        let LookUpURLInProgTests =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let LookUpHeadersInProgTests = this.$apikeyPost;
        let LookUpRequestInProgTests = {
          ServiceType: "WaterTesting",
          RequestType: "CFUTestDetails",
          DataDict: [
            {
              TestID: item.TestID,
            },
          ],
        };
        axios
          .post(
            LookUpURLInProgTests,
            LookUpRequestInProgTests,
            LookUpHeadersInProgTests
          )
          .then((response) => {
            this.PseudomonasObject.TestResult = response.data.Values[0][7];
            (this.PseudomonasObject.TestID = item.TestID),
              (this.PseudomonasObject.Location = this.selectedlocation),
              (this.PseudomonasObject.CompletedBy = this.company),
              (this.PseudomonasObject.SampleID = item.SampleID),
              (this.PseudomonasObject.SampleLocation = item.SampleLocation),
              (this.PseudomonasObject.SampleDate = item.SampleDate),
              (this.PseudomonasObject.SampleTime = item.SampleTime),
              (this.PseudomonasObject.OutletType = item.OutletType),
              (this.PseudomonasObject.FlushType = item.FlushType),
              (this.PseudomonasObject.Desc = item.Desc);
            (this.PseudomonasObject.PseuVar1 = response.data.Values[0][16]),
              (this.PseudomonasObject.PseuVar2 = response.data.Values[0][17]),
              (this.PseudomonasObject.PseuVar3 = response.data.Values[0][18]),
              (this.PseudomonasObject.PseuVar4 = response.data.Values[0][19]),
              (this.PseudomonasObject.PseuVar5 = response.data.Values[0][20]),
              (this.PseudomonasObject.PseuVar6 = response.data.Values[0][21]),
              // this.PseudomonasObject.TestResult = item.TestResult;
              (this.PseudomonasObject.TestCommencedDate = this.FormatDate(
                response.data.Values[0][10]
              )),
              (this.PseudomonasObject.TestCommencedTime =
                response.data.Values[0][11]);
          });
      } else if (Type == "Rapid" && Variant == "Legionella") {
        let LookUpURLInProgTests =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let LookUpHeadersInProgTests = this.$apikeyPost;
        let LookUpRequestInProgTests = {
          ServiceType: "WaterTesting",
          RequestType: "RapidTestDetails",
          DataDict: [
            {
              TestID: item.TestID,
            },
          ],
        };
        axios
          .post(
            LookUpURLInProgTests,
            LookUpRequestInProgTests,
            LookUpHeadersInProgTests
          )
          .then((response) => {
            this.LegionellaObject.TestResult = response.data.Values[0][7];
            (this.LegionellaObject.TestCommencedDate = this.FormatDate(
              response.data.Values[0][10]
            )),
              (this.LegionellaObject.TestCommencedTime =
                response.data.Values[0][11]);

            (this.LegionellaObject.TestID = item.TestID),
              (this.LegionellaObject.Location = this.selectedlocation),
              (this.LegionellaObject.CompletedBy = this.company);
            (this.LegionellaObject.SampleID = item.SampleID),
              (this.LegionellaObject.SampleLocation = item.SampleLocation),
              (this.LegionellaObject.SampleDate = item.SampleDate),
              (this.LegionellaObject.SampleTime = item.SampleTime),
              (this.LegionellaObject.OutletType = item.OutletType),
              (this.LegionellaObject.FlushType = item.FlushType),
              (this.LegionellaObject.Desc = item.Desc);
            this.LegionellaObject.MPN = response.data.Values[0][12];
          });
      } else if (Type == "Rapid" && Variant == "Pseudomonas") {
        (this.PseudomonasObject.TestID = item.TestID),
          (this.PseudomonasObject.Location = this.selectedlocation),
          (this.PseudomonasObject.CompletedBy = this.company),
          (this.PseudomonasObject.SampleID = item.SampleID),
          (this.PseudomonasObject.SampleLocation = item.SampleLocation),
          (this.PseudomonasObject.SampleDate = item.SampleDate),
          (this.PseudomonasObject.SampleTime = item.SampleTime),
          (this.PseudomonasObject.OutletType = item.OutletType),
          (this.PseudomonasObject.FlushType = item.FlushType),
          (this.PseudomonasObject.Desc = item.Desc);

        let LookUpURLInProgTests =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let LookUpHeadersInProgTests = this.$apikeyPost;
        let LookUpRequestInProgTests = {
          ServiceType: "WaterTesting",
          RequestType: "RapidTestDetails",
          DataDict: [
            {
              TestID: item.TestID,
            },
          ],
        };
        axios
          .post(
            LookUpURLInProgTests,
            LookUpRequestInProgTests,
            LookUpHeadersInProgTests
          )
          .then((response) => {
            this.PseudomonasObject.TestResult = response.data.Values[0][7];
            (this.PseudomonasObject.TestCommencedDate = this.FormatDate(
              response.data.Values[0][10]
            )),
              (this.PseudomonasObject.TestCommencedTime =
                response.data.Values[0][11]);

            (this.PseudomonasObject.TestID = item.TestID),
              (this.PseudomonasObject.Location = this.selectedlocation),
              (this.PseudomonasObject.CompletedBy = this.company),
              (this.PseudomonasObject.SampleID = item.SampleID),
              (this.PseudomonasObject.SampleLocation = item.SampleLocation),
              (this.PseudomonasObject.SampleDate = item.SampleDate),
              (this.PseudomonasObject.SampleTime = item.SampleTime),
              (this.PseudomonasObject.OutletType = item.OutletType),
              (this.PseudomonasObject.FlushType = item.FlushType),
              (this.PseudomonasObject.Desc = item.Desc);
            this.PseudomonasObject.MPN = response.data.Values[0][14];
          });
      }
    },
    SubmitForm(Type, Variant) {
      if (Type == "Colony" && Variant == "Legionella") {
        if (
          this.LegionellaObject.TestCommencedDate == null ||
          this.LegionellaObject.TestCommencedTime == null ||
          this.LegionellaObject.LegVar1 == null ||
          this.LegionellaObject.LegVar1 == "" ||
          this.LegionellaObject.LegVar2 == null ||
          this.LegionellaObject.LegVar2 == "" ||
          this.LegionellaObject.LegVar3 == null ||
          this.LegionellaObject.LegVar3 == "" ||
          this.LegionellaObject.LegVar4 == null ||
          this.LegionellaObject.LegVar4 == "" ||
          this.LegionellaObject.TestResult == null
        ) {
          alert("Please complete all fields prior to submission");
        } else {
          alert("Results Submitted Successfully");

          let name = localStorage.getItem("fullname");
          let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/wms";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest = {
            ServiceType: "WaterTesting",
            RequestType: "SubmitTestResult",
            DataDict: [
              {
                Category: "Colony",
                TestResult: this.LegionellaObject.TestResult,
                TestCertificate: "TRUE",
                TestCommencedDate: this.LegionellaObject.TestCommencedDate,
                TestCommencedTime: this.LegionellaObject.TestCommencedTime,
                Legionella: this.LegionellaObject.LegVar1,
                LegionellaPSG1: this.LegionellaObject.LegVar2,
                LegionellaPSG2: this.LegionellaObject.LegVar3,
                LegionellaNonP: this.LegionellaObject.LegVar4,
                Aeroplate37MW3: "",
                Aeroplate32MW3: "",
                PseudoMW4: "",
                ColiformsMW10: "",
                EColiMW10: "",
                PseudoMW32: "",
                CompletedBy: name,
                TestID: this.LegionellaObject.TestID,
              },
            ],
          };

          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              response;
              this.ResultsInput = "False";
              this.TableRefresh(Type, Variant);
            });
        }
      } else if (Type == "Colony" && Variant == "Pseudomonas") {
        if (
          this.PseudomonasObject.TestCommencedDate == null ||
          this.PseudomonasObject.TestCommencedTime == null ||
          this.PseudomonasObject.PseuVar1 == null ||
          this.PseudomonasObject.PseuVar1 == "" ||
          this.PseudomonasObject.PseuVar2 == null ||
          this.PseudomonasObject.PseuVar2 == "" ||
          this.PseudomonasObject.PseuVar3 == null ||
          this.PseudomonasObject.PseuVar3 == "" ||
          this.PseudomonasObject.PseuVar4 == null ||
          this.PseudomonasObject.PseuVar4 == "" ||
          this.PseudomonasObject.PseuVar5 == null ||
          this.PseudomonasObject.PseuVar5 == "" ||
          this.PseudomonasObject.PseuVar6 == null ||
          this.PseudomonasObject.PseuVar6 == "" ||
          this.PseudomonasObject.TestResult == null
        ) {
          alert("Please complete all fields prior to submission");
        } else {
          alert("Results Submitted Successfully");

          let name = localStorage.getItem("fullname");
          let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/wms";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest = {
            ServiceType: "WaterTesting",
            RequestType: "SubmitTestResult",
            DataDict: [
              {
                Category: "Colony",
                TestResult: this.PseudomonasObject.TestResult,
                TestCertificate: "TRUE",
                TestCommencedDate: this.PseudomonasObject.TestCommencedDate,
                TestCommencedTime: this.PseudomonasObject.TestCommencedTime,
                Legionella: "",
                LegionellaPSG1: "",
                LegionellaPSG2: "",
                LegionellaNonP: "",
                Aeroplate37MW3: this.PseudomonasObject.PseuVar1,
                Aeroplate32MW3: this.PseudomonasObject.PseuVar2,
                PseudoMW4: this.PseudomonasObject.PseuVar3,
                ColiformsMW10: this.PseudomonasObject.PseuVar4,
                EColiMW10: this.PseudomonasObject.PseuVar5,
                PseudoMW32: this.PseudomonasObject.PseuVar6,
                CompletedBy: name,
                TestID: this.PseudomonasObject.TestID,
              },
            ],
          };

          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              response;
              this.ResultsInput = "False";
              this.TableRefresh(Type, Variant);
            });
        }
      } else if (Type == "Rapid" && Variant == "Legionella") {
        if (
          this.LegionellaObject.TestCommencedDate == null ||
          this.LegionellaObject.TestCommencedTime == null ||
          this.LegionellaObject.MPN == null ||
          this.LegionellaObject.MPN == "" ||
          this.LegionellaObject.TestResult == null
        ) {
          alert("Please complete all fields prior to submission");
        } else {
          alert("Results Submitted Successfully");

          let name = localStorage.getItem("fullname");
          let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/wms";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest = {
            RequestType: "SubmitTestResult",
            ServiceType: "WaterTesting",
            DataDict: [
              {
                Category: "Rapid",
                TestResult: this.LegionellaObject.TestResult,
                TestCertificate: "TRUE",
                TestCommencedDate: this.LegionellaObject.TestCommencedDate,
                TestCommencedTime: this.LegionellaObject.TestCommencedTime,
                LegionellaMPN: this.LegionellaObject.MPN,
                LegionellaResult: this.LegionellaObject.TestResult,
                PseudomonasMPN: "",
                PseudomonasResult: "",
                CompletedBy: name,
                TestID: this.LegionellaObject.TestID,
              },
            ],
          };

          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              response;
              this.ResultsInput = "False";
              this.TableRefresh(Type, Variant);
            });
        }
      } else if (Type == "Rapid" && Variant == "Pseudomonas") {
        if (
          this.PseudomonasObject.TestCommencedDate == null ||
          this.PseudomonasObject.TestCommencedTime == null ||
          this.PseudomonasObject.MPN == null ||
          this.PseudomonasObject.MPN == "" ||
          this.PseudomonasObject.TestResult == null
        ) {
          alert("Please complete all fields prior to submission");
        } else {
          alert("Results Submitted Successfully");

          let name = localStorage.getItem("fullname");
          let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/wms";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest = {
            RequestType: "SubmitTestResult",
            ServiceType: "WaterTesting",
            DataDict: [
              {
                Category: "Rapid",
                TestResult: this.PseudomonasObject.TestResult,
                TestCertificate: "TRUE",
                TestCommencedDate: this.PseudomonasObject.TestCommencedDate,
                TestCommencedTime: this.PseudomonasObject.TestCommencedTime,
                LegionellaMPN: "",
                LegionellaResult: "",
                PseudomonasMPN: this.PseudomonasObject.MPN,
                PseudomonasResult: this.PseudomonasObject.TestResult,
                CompletedBy: name,
                TestID: this.PseudomonasObject.TestID,
              },
            ],
          };

          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              response;
              this.ResultsInput = "False";
              this.TableRefresh(Type, Variant);
            });
        }
      }
    },
    Submit4EyeCheckForm(Type, Variant) {
      if ((Type == "Rapid") & (Variant == "Pseudomonas")) {
         let Reccomendations = "";
        if (this.PseudomonasObject.Recommendations == null) {
          Reccomendations = "";
        } else {
          Reccomendations = this.PseudomonasObject.Recommendations;
        }
        let LookUpUrlDetails =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let LookUpHeadersDetails = this.$apikeyPost;
        let LookUpRequestDetails = {
          ServiceType: "WaterTesting",
          RequestType: "AddWaterTestOutcome",
          DataDict: [
            {
              TestID: this.PseudomonasObject.TestID,
              Category: "Rapid",
              Recommendations:Reccomendations,
              ActionsList: this.NewActionsList,
            },
          ],
        };
        axios
          .post(LookUpUrlDetails, LookUpRequestDetails, LookUpHeadersDetails)
          .then((response) => {
            response;
            this.ResultsInput = "False";

            this.NewActionsList = [];
            this.TableRefresh();
          });
      } else if ((Type == "Colony") & (Variant == "Pseudomonas")) {
        let Reccomendations = "";
        if (this.PseudomonasObject.Recommendations == null) {
          Reccomendations = "";
        } else {
          Reccomendations = this.PseudomonasObject.Recommendations;
        }
        let LookUpUrlDetails =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let LookUpHeadersDetails = this.$apikeyPost;
        let LookUpRequestDetails = {
          ServiceType: "WaterTesting",
          RequestType: "AddWaterTestOutcome",
          DataDict: [
            {
              TestID: this.PseudomonasObject.TestID,
              Category: "Colony",
              Recommendations: Reccomendations,
              ActionsList: this.NewActionsList,
            },
          ],
        };
        axios
          .post(LookUpUrlDetails, LookUpRequestDetails, LookUpHeadersDetails)
          .then((response) => {
            (response);
            this.ResultsInput = "False";

            this.NewActionsList = [];
            this.TableRefresh();
          });
      } else if ((Type == "Rapid") & (Variant == "Legionella")) {

         let Reccomendations = "";
        if (this.LegionellaObject.Recommendations == null) {
          Reccomendations = "";
        } else {
          Reccomendations = this.LegionellaObject.Recommendations;
        }
        let LookUpUrlDetails =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let LookUpHeadersDetails = this.$apikeyPost;
        let LookUpRequestDetails = {
          ServiceType: "WaterTesting",
          RequestType: "AddWaterTestOutcome",
          DataDict: [
            {
              TestID: this.LegionellaObject.TestID,
              Category: "Rapid",
              Recommendations:Reccomendations,
              ActionsList: this.NewActionsList,
            },
          ],
        };
        axios
          .post(LookUpUrlDetails, LookUpRequestDetails, LookUpHeadersDetails)
          .then((response) => {
            response;
            this.ResultsInput = "False";

            this.NewActionsList = [];
            this.TableRefresh();
          });
      } else if ((Type == "Colony") & (Variant == "Legionella")) {
         let Reccomendations = "";
        if (this.LegionellaObject.Recommendations == null) {
          Reccomendations = "";
        } else {
          Reccomendations = this.LegionellaObject.Recommendations;
        }
        let LookUpUrlDetails =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/wms";
        let LookUpHeadersDetails = this.$apikeyPost;
        let LookUpRequestDetails = {
          ServiceType: "WaterTesting",
          RequestType: "AddWaterTestOutcome",
          DataDict: [
            {
              TestID: this.LegionellaObject.TestID,
              Category: "Colony",
              Recommendations: Reccomendations,
              ActionsList: this.NewActionsList,
            },
          ],
        };
        axios
          .post(LookUpUrlDetails, LookUpRequestDetails, LookUpHeadersDetails)
          .then((response) => {
            response;
            this.ResultsInput = "False";

            this.NewActionsList = [];
            this.TableRefresh();
          });
      }
    },
    ChangeTab() {
      this.ResultsInput = "False";
    },
    ViewCompleted(item) {
      this.ModalVar = item;
      this.$refs["ViewCompletedModal"].show(this.ModalVar);
    },
    CancelForm(Type, Variant) {
      if (Type == "Colony" && Variant == "Legionella") {
        (this.LegionellaObject.TestID = null),
          (this.LegionellaObject.Location = null),
          (this.LegionellaObject.CompletedBy = null),
          (this.LegionellaObject.SampleID = null),
          (this.LegionellaObject.SampleDate = null),
          (this.LegionellaObject.SampleTime = null),
          (this.LegionellaObject.SampleLocation = null),
          (this.LegionellaObject.Desc = null),
          (this.LegionellaObject.OutletType = null),
          (this.LegionellaObject.FlushType = null),
          (this.LegionellaObject.TestCommencedTime = null),
          (this.LegionellaObject.TestCommencedDate = null),
          (this.LegionellaObject.LegVar1 = "Not Detected"),
          (this.LegionellaObject.LegVar2 = "Not Detected"),
          (this.LegionellaObject.LegVar3 = "Not Detected"),
          (this.LegionellaObject.LegVar4 = "Not Detected"),
          (this.LegionellaObject.TestResult = null);
      } else if (Type == "Colony" && Variant == "Pseudomonas") {
        (this.PseudomonasObject.TestID = null),
          (this.PseudomonasObject.Location = null),
          (this.PseudomonasObject.CompletedBy = null),
          (this.PseudomonasObject.SampleID = null),
          (this.PseudomonasObject.SampleLocation = null),
          (this.PseudomonasObject.SampleDate = null),
          (this.PseudomonasObject.SampleTime = null),
          (this.PseudomonasObject.OutletType = null),
          (this.PseudomonasObject.FlushType = null),
          (this.PseudomonasObject.Desc = null),
          (this.PseudomonasObject.PseuVar1 = "Not Detected"),
          (this.PseudomonasObject.PseuVar2 = "Not Detected"),
          (this.PseudomonasObject.PseuVar3 = "Not Detected"),
          (this.PseudomonasObject.PseuVar4 = "Not Detected"),
          (this.PseudomonasObject.PseuVar5 = "Not Detected"),
          (this.PseudomonasObject.PseuVar6 = "Not Detected"),
          (this.PseudomonasObject.TestResult = null);
      } else if (Type == "Rapid" && Variant == "Legionella") {
        (this.LegionellaObject.TestID = null),
          (this.LegionellaObject.Location = null),
          (this.LegionellaObject.CompletedBy = null),
          (this.LegionellaObject.SampleID = null),
          (this.LegionellaObject.SampleDate = null),
          (this.LegionellaObject.SampleTime = null),
          (this.LegionellaObject.SampleLocation = null),
          (this.LegionellaObject.Desc = null),
          (this.LegionellaObject.OutletType = null),
          (this.LegionellaObject.FlushType = null),
          (this.LegionellaObject.TestCommencedTime = null),
          (this.LegionellaObject.TestCommencedDate = null),
          (this.LegionellaObject.MPN = "Not Detected");
        this.LegionellaObject.TestResult = null;
      } else if (Type == "Rapid" && Variant == "Pseudomonas") {
        (this.PseudomonasObject.TestID = null),
          (this.PseudomonasObject.Location = null),
          (this.PseudomonasObject.CompletedBy = null),
          (this.PseudomonasObject.SampleID = null),
          (this.PseudomonasObject.SampleLocation = null),
          (this.PseudomonasObject.SampleDate = null),
          (this.PseudomonasObject.SampleTime = null),
          (this.PseudomonasObject.OutletType = null),
          (this.PseudomonasObject.FlushType = null),
          (this.PseudomonasObject.Desc = null),
          (this.PseudomonasObject.TestResult = null),
          (this.PseudomonasObject.MPN = "Not Detected");
      }
      this.ResultsInput = "False";
    },
    showCompleteDetails(item) {
      let SpeedofTest = "";
      let testtype = "";

      if (item.TestVariant == "Colony") {
        SpeedofTest = "CFUTestDetails";
        testtype = "CFU";
      }
      if (item.TestVariant == "Rapid") {
        SpeedofTest = "RapidTestDetails";
        testtype = "Rapid";
      }

      let LookUpUrlDetails =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersDetails = this.$apikeyPost;
      let LookUpRequestDetails = {
        ServiceType: "WaterTesting",
        RequestType: SpeedofTest,
        DataDict: [
          {
            TestID: item.TestID,
          },
        ],
      };
      axios
        .post(LookUpUrlDetails, LookUpRequestDetails, LookUpHeadersDetails)
        .then((response) => {
          this.modalDetails = response.data.Values[0];
          this.modalItem = item;
          this.modalItem[0] = item.TestID;
          this.testtype = testtype;
          this.TestLegion = item.LegionellaResult;
          this.TestPseudo = item.PseudomonasResult;
          this.TestResult = item.TestResult;
          this.testStatus = this.modalDetails[8];

          Vue.prototype.$modalDetails = this.modalDetails;

          if (this.TestLegion == "Pass") {
            this.LegionColour = "success";
          } else if (this.TestLegion == "Fail") {
            this.LegionColour = "danger";
          } else {
            this.LegionColour = "secondary";
          }

          if (this.TestPseudo == "Pass") {
            this.PseudoColour = "success";
          } else if (this.TestPseudo == "Fail") {
            this.PseudoColour = "danger";
          } else {
            this.PseudoColour = "secondary";
          }

          if (this.TestResult == "Pass") {
            this.OverallColour = "success";
          } else if (this.TestResult == "Fail") {
            this.OverallColour = "danger";
          } else {
            this.OverallColour = "secondary";
          }

          this.$refs["TestResultsModal"].show(
            this.testvar,
            this.testtype,
            this.LegionColour,
            this.PseudoColour,
            this.OverallColour
          );
        });
    },
    showDetailsColony() {
      this.ColonyDetails = this.modalDetails;
      this.TestVariant = this.modalItem.TestVariant;
      this.$refs["ColonyDetail"].show(this.TestVariant);
    },

    TableRefresh() {
      this.LegionellaColonyForResults = [];
      (this.PseudomonasColonyForResults = []),
        (this.LegionellaRapidForResults = []),
        (this.PseudomonasRapidForResults = []),
        (this.PseudomonasObject.TestID = null),
        (this.PseudomonasObject.Location = null),
        (this.PseudomonasObject.CompletedBy = null),
        (this.PseudomonasObject.SampleID = null),
        (this.PseudomonasObject.SampleLocation = null),
        (this.PseudomonasObject.SampleDate = null),
        (this.PseudomonasObject.SampleTime = null),
        (this.PseudomonasObject.OutletType = null),
        (this.PseudomonasObject.FlushType = null),
        (this.PseudomonasObject.Desc = null),
        (this.PseudomonasObject.PseuVar1 = "Not Detected"),
        (this.PseudomonasObject.PseuVar2 = "Not Detected"),
        (this.PseudomonasObject.PseuVar3 = "Not Detected"),
        (this.PseudomonasObject.PseuVar4 = "Not Detected"),
        (this.PseudomonasObject.PseuVar5 = "Not Detected"),
        (this.PseudomonasObject.PseuVar6 = "Not Detected"),
        (this.PseudomonasObject.TestResult = null);
      (this.LegionellaObject.TestID = null),
        (this.LegionellaObject.Location = null),
        (this.LegionellaObject.CompletedBy = null),
        (this.LegionellaObject.SampleID = null),
        (this.LegionellaObject.SampleDate = null),
        (this.LegionellaObject.SampleTime = null),
        (this.LegionellaObject.SampleLocation = null),
        (this.LegionellaObject.Desc = null),
        (this.LegionellaObject.OutletType = null),
        (this.LegionellaObject.FlushType = null),
        (this.LegionellaObject.TestCommencedTime = null),
        (this.LegionellaObject.TestCommencedDate = null),
        (this.LegionellaObject.LegVar1 = "Not Detected"),
        (this.LegionellaObject.LegVar2 = "Not Detected"),
        (this.LegionellaObject.LegVar3 = "Not Detected"),
        (this.LegionellaObject.LegVar4 = "Not Detected"),
        (this.LegionellaObject.TestResult = null),
        (this.PseudomonasObject.TestID = null),
        (this.PseudomonasObject.Location = null),
        (this.PseudomonasObject.CompletedBy = null),
        (this.PseudomonasObject.SampleID = null),
        (this.PseudomonasObject.SampleLocation = null),
        (this.PseudomonasObject.SampleDate = null),
        (this.PseudomonasObject.SampleTime = null),
        (this.PseudomonasObject.OutletType = null),
        (this.PseudomonasObject.FlushType = null),
        (this.PseudomonasObject.Desc = null),
        (this.PseudomonasObject.TestResult = null),
        (this.PseudomonasObject.MPN = "Not Detected");

      (this.LegionellaObject.TestID = null),
        (this.LegionellaObject.Location = null),
        (this.LegionellaObject.CompletedBy = null),
        (this.LegionellaObject.SampleID = null),
        (this.LegionellaObject.SampleDate = null),
        (this.LegionellaObject.SampleTime = null),
        (this.LegionellaObject.SampleLocation = null),
        (this.LegionellaObject.Desc = null),
        (this.LegionellaObject.OutletType = null),
        (this.LegionellaObject.FlushType = null),
        (this.LegionellaObject.TestCommencedTime = null),
        (this.LegionellaObject.TestCommencedDate = null),
        (this.LegionellaObject.TestResult = null),
        (this.LegionellaObject.MPN = "Not Detected");

      this.LegionellaColonyArray = "";
      this.PseudomonasColonyArray = "";
      this.LegionellaRapidArray = "";
      this.PseudomonasRapidArray = "";

      let LookUpURLNewTests =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersNewTests = this.$apikeyPost;
      let LookUpRequestNewTests = {
        ServiceType: "WaterTesting",
        RequestType: "NewTests",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(LookUpURLNewTests, LookUpRequestNewTests, LookUpHeadersNewTests)
        .then((response) => {
          this.LegionellaColonyArray = response.data.NewCFULegionella;
          this.PseudomonasColonyArray = response.data.NewCFUPseudomonas;
          this.LegionellaRapidArray = response.data.NewRapidLegionella;
          this.PseudomonasRapidArray = response.data.NewRapidPseudomonas;

          for (let i = 0; i < this.LegionellaColonyArray.length; i++) {
            this.LegionellaColonyForResults.push({
              TestID: this.LegionellaColonyArray[i][0],
              SampleID: this.LegionellaColonyArray[i][1],
              SampleDate: this.LegionellaColonyArray[i][2],
              SampleTime: this.LegionellaColonyArray[i][3],
              SampleLocation: this.LegionellaColonyArray[i][4],
              Desc: this.LegionellaColonyArray[i][5],
              FlushType: this.LegionellaColonyArray[i][6],
              OutletType: this.LegionellaColonyArray[i][7],
              Update: null,
            });
          }

          for (let i = 0; i < this.PseudomonasColonyArray.length; i++) {
            this.PseudomonasColonyForResults.push({
              TestID: this.PseudomonasColonyArray[i][0],
              SampleID: this.PseudomonasColonyArray[i][1],
              SampleDate: this.PseudomonasColonyArray[i][2],
              SampleTime: this.PseudomonasColonyArray[i][3],
              SampleLocation: this.PseudomonasColonyArray[i][4],
              Desc: this.PseudomonasColonyArray[i][5],
              FlushType: this.PseudomonasColonyArray[i][6],
              OutletType: this.PseudomonasColonyArray[i][7],
              Update: null,
            });
          }

          for (let i = 0; i < this.LegionellaRapidArray.length; i++) {
            this.LegionellaRapidForResults.push({
              TestID: this.LegionellaRapidArray[i][0],
              SampleID: this.LegionellaRapidArray[i][1],
              SampleDate: this.LegionellaRapidArray[i][2],
              SampleTime: this.LegionellaRapidArray[i][3],
              SampleLocation: this.LegionellaRapidArray[i][4],
              Desc: this.LegionellaRapidArray[i][5],
              FlushType: this.LegionellaRapidArray[i][6],
              OutletType: this.LegionellaRapidArray[i][7],
              Update: null,
            });
          }

          for (let i = 0; i < this.PseudomonasRapidArray.length; i++) {
            this.PseudomonasRapidForResults.push({
              TestID: this.PseudomonasRapidArray[i][0],
              SampleID: this.PseudomonasRapidArray[i][1],
              SampleDate: this.PseudomonasRapidArray[i][2],
              SampleTime: this.PseudomonasRapidArray[i][3],
              SampleLocation: this.PseudomonasRapidArray[i][4],
              Desc: this.PseudomonasRapidArray[i][5],
              FlushType: this.PseudomonasRapidArray[i][6],
              OutletType: this.PseudomonasRapidArray[i][7],
              Update: null,
            });
          }
        });

      let LookUpURLCompletedTests =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersCompletedTests = this.$apikeyPost;
      let LookUpRequestCompletedTests = {
        ServiceType: "WaterTesting",
        RequestType: "CompletedTests",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpURLCompletedTests,
          LookUpRequestCompletedTests,
          LookUpHeadersCompletedTests
        )
        .then((response) => {
          this.CompletedTestArray = response.data.Values;
          this.CompletedTestsItems = [];
          for (let i = 0; i < this.CompletedTestArray.length; i++) {
            this.CompletedTestsItems.push({
              TestID: this.CompletedTestArray[i][0],
              TestType: this.CompletedTestArray[i][1],
              TestDesc: this.CompletedTestArray[i][3],
              SampleDate: this.CompletedTestArray[i][4],
              TestResult: this.CompletedTestArray[i][5],
              TestStatus: this.CompletedTestArray[i][6],
              TestVariant: this.CompletedTestArray[i][2],
            });
          }
        });

      let LookUpURLInProgTests =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersInProgTests = this.$apikeyPost;
      let LookUpRequestInProgTests = {
        ServiceType: "WaterTesting",
        RequestType: "InProgressTests",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpURLInProgTests,
          LookUpRequestInProgTests,
          LookUpHeadersInProgTests
        )
        .then((response) => {
          (this.LegionellaColonyForInProg = []),
            (this.PseudomonasColonyForInProg = []),
            (this.LegionellaRapidForInProg = []);
          this.PseudomonasRapidForInProg = [];

          let legionellaColArr = response.data.InProgCFULegionella;
          let legionellaRapidArr = response.data.InProgRapidLegionella;
          let PseudomonasColArr = response.data.InProgCFUPseudomonas;
          let PseudomonasRapidArr = response.data.InProgRapidPseudomonas;

          for (let i = 0; i < legionellaColArr.length; i++) {
            this.LegionellaColonyForInProg.push({
              TestID: legionellaColArr[i][0],
              SampleID: legionellaColArr[i][1],
              SampleDate: legionellaColArr[i][2],
              SampleTime: legionellaColArr[i][3],
              SampleLocation: legionellaColArr[i][4],
              Desc: legionellaColArr[i][5],
              FlushType: legionellaColArr[i][6],
              OutletType: legionellaColArr[i][7],
              Update: null,
            });
          }

          for (let i = 0; i < PseudomonasColArr.length; i++) {
            this.PseudomonasColonyForInProg.push({
              TestID: PseudomonasColArr[i][0],
              SampleID: PseudomonasColArr[i][1],
              SampleDate: PseudomonasColArr[i][2],
              SampleTime: PseudomonasColArr[i][3],
              SampleLocation: PseudomonasColArr[i][4],
              Desc: PseudomonasColArr[i][5],
              FlushType: PseudomonasColArr[i][6],
              OutletType: PseudomonasColArr[i][7],
              Update: null,
            });
          }

          for (let i = 0; i < legionellaRapidArr.length; i++) {
            this.LegionellaRapidForInProg.push({
              TestID: legionellaRapidArr[i][0],
              SampleID: legionellaRapidArr[i][1],
              SampleDate: legionellaRapidArr[i][2],
              SampleTime: legionellaRapidArr[i][3],
              SampleLocation: legionellaRapidArr[i][4],
              Desc: legionellaRapidArr[i][5],
              FlushType: legionellaRapidArr[i][6],
              OutletType: legionellaRapidArr[i][7],
              Update: null,
            });
          }

          for (let i = 0; i < PseudomonasRapidArr.length; i++) {
            this.PseudomonasRapidForInProg.push({
              TestID: PseudomonasRapidArr[i][0],
              SampleID: PseudomonasRapidArr[i][1],
              SampleDate: PseudomonasRapidArr[i][2],
              SampleTime: PseudomonasRapidArr[i][3],
              SampleLocation: PseudomonasRapidArr[i][4],
              Desc: PseudomonasRapidArr[i][5],
              FlushType: PseudomonasRapidArr[i][6],
              OutletType: PseudomonasRapidArr[i][7],
              Update: null,
            });
          }
        });
    },
  },
};
</script>

<style>
input {
  width: 100%;
}

.headercol {
  border-bottom: solid 2px lightgrey;
  font-weight: bold;
  margin: 0;
  padding: 5px;
}
.bodycol {
  padding: 5px;
}
.actionrow {
  margin-left: auto;
  margin-right: auto;
}

.centered {
  text-align: center;
}
</style>
